<template>
    <div class="pt-3" :class="((me) ? '' : 'p-5')">

        <div v-if="shouldShowChatConversation" @click.self="shouldShowChatConversation = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_chat_conversation" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="chat-dialog-messages-list" style="max-height: 500px; overflow: auto;">
                                    <div>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in bland_transcription.messages" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.role == 'assistant' || !item.role"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.role == 'user'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.custom_name">
                                                        <span class="mr-auto primary-color text-bold">{{ item.custom_name }}</span>
                                                    </span>
                                                    <span v-else>
                                                        <span v-if="!item.role" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                        <span v-else>
                                                            <span v-if="item.role == 'assistant'" class="mr-auto primary-color text-bold">AI Agent</span>
                                                            <span v-else class="mr-auto warning-color text-bold">Customer</span>
                                                        </span>
                                                    </span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp || item.created_at) }} . </span>
                                                    <div class="text-sm">{{ item.content }} </div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="shouldShowChatConversation = false">
                            CLOSE
                        </button>

                        <button
                                class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                                :class="{ spinner: sendingAiMessage }"
                                @click="sendAiReply()"
                                :disabled="!new_ai_message"
                        >
                            SEND
                        </button>

                        <div style="float: right; padding-right: 30px; padding-top: 6px;">
                            <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                        </div>

                        <div class="clearfix"></div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

        <div v-if="showBlandRecording" @click.self="showBlandRecording = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-2/3 lg:w-2/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                        <div class="float-right -mb-4" style="position: relative;">
                            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->

                            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="translateTexts('bland', 'spanish')">
                                <i class="mdi mdi-text-box-edit-outline"></i> TRANSLATE TO ENGLISH
                            </button>
                        </div>

                        <div class="float-right -mb-4" style="position: relative;">
                            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="ai_messages_lead.show_ai_feedback = !ai_messages_lead.show_ai_feedback || true;">
                                <i class="mdi mdi-robot-outline"></i>
                                &nbsp;
                                <span v-if="ai_messages_lead.ai_feedback_urgent">🚨</span>
                                &nbsp;
                                <strong v-if="ai_messages_lead.ai_feedback">AI FEEDBACK</strong><span v-else="">AI FEEDBACK</span>
                            </button>

                            <div v-show="ai_messages_lead.show_ai_feedback" style="position: absolute; background: #FFFFFF; padding: 10px; border: solid 1px #CCCCCC; width: 250px; z-index: 1; margin-top: 40px;">
                                <textarea v-model="ai_messages_lead.ai_feedback" style="padding: 10px; width: 100%; height: 200px; border: solid 1px #CCCCCC; border-radius: 5px;"></textarea>

                                <br />

                                <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_feedback_urgent" label="Urgent"></v-switch>

                                <br />

                                <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="saveAiFeedback(ai_messages_lead)">
                                    SAVE
                                </button>

                                <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 w-full w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="ai_messages_lead.show_ai_feedback = false;">
                                    CLOSE
                                </button>
                            </div>
                        </div>

                    <div style="clear: both; padding-top: 10px;"></div>

                    <div>
                        <div v-if="loading_bland_recording" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="bl-audio-el-here"></div>
                            </div>
                            <div class="w-full">
                                <hr />
                                <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                    <div v-if="!bland_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div v-if="bland_recording_data.lead_type == 'PHONE_CALL'">
                                            <div class="flex flex-row flex-wrap w-full">
                                                <div :class="'w-full lg:w-1/2'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                    <br />
                                                    <div>
                                                        <b-list-group>
                                                            <b-list-group-item
                                                                v-for="(item, index) in bland_recording_data.transcription" :key="index"
                                                        
                                                                    class="d-flex align-items-center mb-4 pb-4"
                                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                                                    v-if="index !== 'messages'"
                                                            >
                                                                <b-avatar v-if="item.speaker == 'A'"
                                                                        text="S1"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <b-avatar v-if="item.speaker == 'B'"
                                                                        text="S2"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <div>
                                                                    <span v-if="item.speaker == 'A'" class="mr-auto primary-color text-bold">AI</span>
                                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, bland_recording_data.transcription[0].start) }} . </span>
                                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                    <div class="text-sm">{{ item.text }}</div>
                                                                </div>
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </div>
                                                <div :class="'w-full lg:w-1/2 pl-3'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Summary</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.summary || "No summary found." }}</div>

                                                    <!-- <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Sentiment</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.sentiment || "UNKNOWN" }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Topics Discussed</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.topics_discussed || "No topics discussed." }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Issues Raised</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.issues_raised || "No issues raised." }}</div> -->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Customer Information</div>

                                                    <div style="font-size: 12px;">
                                                        <strong>Customer's name:</strong> {{ bland_recording_data.customer_name || "-" }}
                                                        <br />
                                                        <strong>Customer's email:</strong> {{ bland_recording_data.customer_email || "-" }}
                                                        <br />
                                                        <strong>Customer's phone:</strong> {{ bland_recording_data.ai_provided_phone_number || "-" }}
                                                        <br />
                                                        <strong>Service needed:</strong> {{ bland_recording_data.job_type || "-" }}
                                                        <br /><br />
                                                        <strong>Call ended by:</strong> {{ bland_recording_data.call_ended_by || "-" }}
                                                    </div>

                                                    <!--<div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Analysis</div>

                                                    <div v-if="bland_recording_data.analysis" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.analysis" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No analysis detected.</div>-->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Variables</div>

                                                    <div v-if="bland_recording_data.variables" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.variables" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No variables.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <b-list-group>
                                                <b-list-group-item
                                                    v-for="(item, index) in bland_recording_data.transcription.messages" :key="index"
                                            
                                                        class="d-flex align-items-center mb-4 pb-4"
                                                        style="border: none; border-bottom: solid 1px #ededed;"
                                                >

                                                    <b-avatar v-if="(!item.is_bland && item.sender != 'bot') || item.is_person"
                                                            text="S1"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <b-avatar v-if="(item.is_bland || item.sender == 'bot') && !item.is_person"
                                                            text="S2"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <div>
                                                        <span v-if="item.is_person" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                        <span v-if="(item.is_bland || item.sender == 'bot') && !item.is_person" class="mr-auto primary-color text-bold">AI Agent</span>
                                                        <span v-if="!item.is_bland && item.sender != 'bot' && !item.is_person" class="mr-auto warning-color text-bold">Customer</span>

                                                        <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp) }} . </span>
                                                        <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                        <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                        <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                        <div class="text-sm">
                                                            {{ item.message }}
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </div>
                                </div>

                                <div v-show="bland_recording_data.transcription.messages" class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showBlandRecording = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                            :class="{ spinner: sendingAiMessage }"
                            @click="sendAiReply()"
                            :disabled="!new_ai_message"
                    >
                        SEND
                    </button>

                    <div style="float: right; padding-right: 30px; padding-top: 6px;">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                    </div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaRecordings" @click.self="showLsaRecordings = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_recordings" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="lsa-audio-el-here"></div>

                                <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4" role="alert">
                                    <div>According to Google's policy, you must be logged in to your LSA account in this browser. Please make sure you are logged in on <a href="https://ads.google.com/localservices" target="lsa-account-login">https://ads.google.com/localservices</a> in order to play the recordings in your software.</div>
                                </div>

                                <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                    <div v-if="!lsa_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div>
                                            <div class="flex flex-row flex-wrap w-full">
                                                <div :class="'w-full'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                    <br />
                                                    <div>
                                                        <b-list-group>
                                                            <b-list-group-item
                                                                v-for="(item, index) in lsa_recording_data.transcription" :key="index"
                                                        
                                                                    class="d-flex align-items-center mb-4 pb-4"
                                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                                                    v-if="index !== 'messages'"
                                                            >
                                                                <b-avatar v-if="(item.speaker == 'A' || item.speaker == 'C')"
                                                                        text="S1"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <b-avatar v-if="item.speaker == 'B'"
                                                                        text="S2"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <div>
                                                                    <span v-if="(item.speaker == 'A' || item.speaker == 'C') && lsa_item.sources.indexOf('bland') !== -1" class="mr-auto primary-color text-bold">AI</span>
                                                                    <span v-if="item.speaker == 'A' && lsa_item.sources.indexOf('bland') === -1" class="mr-auto primary-color text-bold">Advertiser</span>
                                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, lsa_recording_data.transcription[0].start) }} . </span>
                                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                    <div class="text-sm">{{ item.text }}</div>
                                                                </div>
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaRecordings = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaMessages" @click.self="showLsaMessages = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 65px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_messages" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="lsa-dialog-messages-list" style="max-height: 450px; overflow: auto;">
                                    <div v-if="lsa_messages_displayed.length == 0" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in lsa_messages_displayed" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.participant_type == 2"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.participant_type == 3"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.participant_type == 2" class="mr-auto primary-color text-bold">Advertiser</span>
                                                    <span v-else class="mr-auto warning-color text-bold">Customer</span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.event_time) }} . </span>
                                                    <div class="text-sm" v-html="item.text"></div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div>
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_lsa_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaMessages = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4"
                            :class="{ spinner: sendingLsaMessage }"
                            @click="sendLsaReply()"
                            :disabled="!new_lsa_message"
                    >
                        SEND
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="show_notes_dialog" @click.self="show_notes_dialog = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                        Notes

                        <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_notes_dialog = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative; overflow: auto;">

                        <div style="clear: both;"></div>

                        <div>

                            <div style="font-size: 12px; padding-bottom: 20px;">
                                <div v-if="activeLead.notes.length == 0">
                                    No notes found.
                                </div>

                                <div v-else>
                                    <div v-for="(note, note_index) in activeLead.notes" style="clear: both; padding-bottom: 10px;">
                                        <div style="float: left; width: calc(100% - 220px);">
                                            {{ note.note }}
                                        </div>

                                        <div style="float: right; width: 200px; text-align: right;">
                                            [{{ formatDate(note.timestamp) }}]

                                            &nbsp;&nbsp;

                                            <a href="javascript: void(0);"><i class="mdi mdi-delete-outline" style="color: red;" @click="deleteNote(note_index)"></i></a>
                                        </div>

                                        <div style='clear: both;'></div>
                                    </div>

                                    <div style='clear: both;'></div>
                                </div>
                            </div>

                            <v-textarea
                                clearable
                                outlined
                                dense
                                hide-details
                                label="Add Note"
                                v-model="new_note"

                                class="white border border-white"
                            ></v-textarea>
                            
                        </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingNote}" @click="saveNote">
                            ADD
                        </button>

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_notes_dialog = false">
                            CLOSE
                        </button>

                    <div class="clearfix"></div>

                    </div>
                </div>
            </div>

            <div v-if="show_photos_dialog"
                 @click.self="show_photos_dialog = false"
                 class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center"
                 style="background-color: rgba(0,0,0,.2);">

                <div class="w-full sm:w-1/2 lg:w-1/2 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                        Photos
                        <a href="javascript:void(0);" class="rg-modal-close-btn" @click="show_photos_dialog = false">
                            <i class="mdi mdi-close"></i>
                        </a>
                    </div>

                    <div class="p-6" style="position: relative; overflow: auto; max-height: 400px;">

                        <!-- NO PHOTOS -->
                        <div v-if="photos.length == 0" style="font-size: 13px;">
                            No photos uploaded.
                        </div>

                        <!-- PHOTO GRID -->
                        <div v-else class="grid grid-cols-2 md:grid-cols-3 gap-4">
                            <div v-for="(photo, index) in photos" :key="index" style="position: relative;">
                                
                                <img :src="photo"
                                     style="width: 100%; height: 150px; object-fit: cover; border-radius: 6px;" />

                                <button @click="removePhoto(index)"
                                        style="position: absolute; top: 5px; right: 5px; background: red; color: white; border: none; border-radius: 50%; width: 25px; height: 25px;">
                                    ✕
                                </button>

                            </div>
                        </div>

                        <!-- FILE INPUT -->
                        <div class="mt-4">
                            <input type="file"
                                   accept="image/*"
                                   @change="handlePhotoUpload"
                                   multiple :disabled="uploading" />

                            <div v-if="uploading" class="pt-3">Uploading... please wait</div>
                        </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right"
                                :class="{'spinner': savingPhotos}"
                                @click="savePhotos">
                            SAVE
                        </button>

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right"
                                @click="show_photos_dialog = false">
                            CLOSE
                        </button>

                        <div class="clearfix"></div>

                    </div>

                </div>
            </div>


        <div class="rg-top-filter pt-1 float-right pl-3"
        :class="(($vuetify.breakpoint.mobile) ? '-mt-2' : '')"
      >
          <v-text-field
              :value="formatDate(date_filter[0], 'MMM DD, YYYY') + '   -   ' + ((date_filter[1]) ? formatDate(date_filter[1], 'MMM DD, YYYY') : '')"
              append-icon="mdi-calendar-blank-outline"
              readonly
              outlined
              dense
              style="width: 230px; background: #4EC5A1; color: #FFFFFF !important; border: 0px !important;"
              hide-details
              placholder="Choose Date"
              @click="show_picker = !show_picker"
          ></v-text-field>
          
          <div v-if="show_picker" style="position: absolute; width: 490px; z-index: 999; margin-left: -260px; background: #FFFFFF; padding: 10px; margin-top: 5px; border-radius: 10px; box-shadow: 0px 0px 30px 0px #E2E2E2;">
            <div style="float: left; border-right: solid 1px #d5d5d5;">
              <div class="mb-2"><strong class="text-sm">Filter by Date</strong></div>

              <v-date-picker
              v-model="date_filter"
              range
              no-title
              scrollable
              @input="menu = false"
              style="border: 0px;"
              >
              <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="#44468F"
                      @click="show_picker = false"
                  >
                      Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="#44468F"
                      @click="filterDate();"
                  >
                      UPDATE
                  </v-btn>
              </v-date-picker>
            </div>

            <div style="float: left; margin-left: 20px; padding-left: 20px; padding-top: 20px;">
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Week')" :style="((selected_date_text == 'This Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Week</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Week')" :style="((selected_date_text == 'Last Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Week</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Month')" :style="((selected_date_text == 'This Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Month</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Month')" :style="((selected_date_text == 'Last Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Month</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 30 days')" :style="((selected_date_text == 'Last 30 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 30 days</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 60 days')" :style="((selected_date_text == 'Last 60 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 60 days</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 90 days')" :style="((selected_date_text == 'Last 90 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 90 days</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Year')" :style="((selected_date_text == 'This Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Year</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Year')" :style="((selected_date_text == 'Last Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Year</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 6 months')" :style="((selected_date_text == 'Last 6 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 6 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 12 months')" :style="((selected_date_text == 'Last 12 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 12 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 24 months')" :style="((selected_date_text == 'Last 24 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 24 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 36 months')" :style="((selected_date_text == 'Last 36 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 36 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('All Time')" :style="((selected_date_text == 'All Time') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">All Time</a></div>
            </div>

            <div style="clear: both;"></div>
          </div>
      </div>

        <h1 class="text-lg font-semibold mb-3">
            
            Dashboard

            <v-chip
                    class="ma-2"
                    color="#44468F"
                    outlined
                    small
            >
                {{ messages.length }}
            </v-chip>
        </h1>
        <hr class="border-b border-gray-100 mb-3">

        <template>
          <v-expansion-panels v-model="panel" accordion flat dense>
              <v-expansion-panel>
              <v-expansion-panel-header>Stats</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <div v-if="!loading && dashboard_data" class="space-y-6 pt-3">

                    <!-- LEADS -->
                    <section>
                      <div class="flex flex-wrap -mx-2">
                        <StatCard
                          title="Total Leads"
                          icon="mdi-account-multiple"
                          :value="dashboard_data.total_leads"
                          :current="dashboard_data.total_leads"
                          :previous="dashboard_data_prev.total_leads"
                          :change="comparisons.total_leads"
                        />

                        <StatCard
                          title="Total Calls"
                          icon="mdi-phone"
                          :value="dashboard_data.total_calls"
                          :current="dashboard_data.total_calls"
                          :previous="dashboard_data_prev.total_calls"
                          :change="comparisons.total_calls"
                          :tooltiptext="'Total Calls might be different than Total Leads because a lead can call multiple times'"
                        />

                        <StatCard
                          title="Connected Calls"
                          icon="mdi-phone-check"
                          :value="dashboard_data.total_connected_calls"
                          :current="dashboard_data.total_connected_calls"
                          :previous="dashboard_data_prev.total_connected_calls"
                          :change="comparisons.total_connected_calls"
                        />

                        <StatCard
                          title="Charged"
                          icon="mdi-cash-check"
                          :value="dashboard_data.charged_leads_total"
                          :current="dashboard_data.charged_leads_total"
                          :previous="dashboard_data_prev.stats.charged_leads_total"
                          :change="comparisons.charged_leads_total"
                          :tooltiptext="'These are the leads that were permanently charged by Google LSA'"
                        />

                        <StatCard
                          title="Message Leads"
                          icon="mdi-message-text"
                          :value="dashboard_data.total_message_leads"
                          :current="dashboard_data.total_message_leads"
                          :previous="dashboard_data_prev.total_message_leads"
                          :change="comparisons.total_message_leads"
                        />

                        <StatCard
                          title="Lead Quality"
                          icon="mdi-poll"
                          :value="dashboard_data.lead_quality"
                          :current="dashboard_data.lead_quality"
                          :previous="dashboard_data_prev.lead_quality"
                          :change="comparisons.lead_quality"
                        />

                        <StatCard
                          title="Not Charged"
                          icon="mdi-cash-remove"
                          :value="dashboard_data.not_charged_leads"
                          :current="dashboard_data.not_charged_leads"
                          :previous="dashboard_data_prev.not_charged_leads"
                          :change="comparisons.not_charged_leads"
                          :tooltiptext="'These are the leads that were not charged by LSA from the moment the leads were created'"
                        />

                        <StatCard
                          title="Qualified Leads"
                          icon="mdi-check-circle"
                          :value="dashboard_data.stats.charged_leads"
                          :current="dashboard_data.stats.charged_leads"
                          :previous="dashboard_data_prev.stats.charged_leads"
                          :change="comparisons.charged_leads"
                        />

                        <StatCard
                          title="Credited"
                          icon="mdi-cash-refund"
                          :value="dashboard_data.stats.approved_disputes"
                          :current="dashboard_data.stats.approved_disputes"
                          :previous="dashboard_data_prev.stats.approved_disputes"
                          :change="comparisons.approved_disputes"
                          :total_refunds="dashboard_data.stats.total_approved_disputes"
                          :refunds_amount="dashboard_data.refunds_amount"
                          :refunds_amount_total="dashboard_data.refunds_amount_total"
                        />

                        <StatCard
                            v-if="getUUID() == '8392ce47-b5e0-440d-b58e-5b6b69492553'"
                          title="Total Conversions"
                          icon="mdi-handshake"
                          :value="dashboard_data.conversions_stats.total_conversions"
                          :current="dashboard_data.conversions_stats.total_conversions"
                          :previous="dashboard_data_prev.conversions_stats.total_conversions"
                          :change="comparisons.total_conversions"
                          :tooltiptext="'These are the total agreements that were signed by the customer.'"
                        />

                        <StatCard
                            v-if="getUUID() == '8392ce47-b5e0-440d-b58e-5b6b69492553'"
                          title="Conversion Rate"
                          icon="mdi-percent"
                          :value="dashboard_data.conversions_stats.conversion_rate"
                          :current="dashboard_data.conversions_stats.conversion_rate"
                          :previous="dashboard_data_prev.conversions_stats.conversion_rate"
                          :change="comparisons.conversion_rate"
                          :tooltiptext="'Percentage of AI conversations that lead to a signature.'"
                        />

                        <StatCard
                            v-if="getUUID() == '8392ce47-b5e0-440d-b58e-5b6b69492553'"
                          title="Pending Estimates"
                          icon="mdi-file-document-outline"
                          :value="dashboard_data.conversions_stats.pending_estimates"
                          :current="dashboard_data.conversions_stats.pending_estimates"
                          :previous="dashboard_data_prev.conversions_stats.pending_estimates"
                          :change="comparisons.pending_estimates"
                          :tooltiptext="'Total value of quotes sent but not yet signed.'"
                        />

                        <!-- <StatCard
                          title="Conversion Rate"
                          icon="mdi-percent"
                          :value="dashboard_data.stats.conversion + '%'"
                          :current="dashboard_data.stats.total_converted_value"
                          :previous="dashboard_data_prev.stats.total_converted_value"
                          :change="comparisons.total_converted_value"
                        />
                        <StatCard
                          title="Response Rate"
                          icon="mdi-clock-check"
                          :value="dashboard_data.stats.lsa_response_rate + '%'"
                          :current="dashboard_data.stats.lsa_response_rate"
                          :previous="dashboard_data_prev.stats.lsa_response_rate"
                          :change="comparisons.lsa_response_rate"
                        />

                        <StatCard
                          title="Under 30s Response"
                          icon="mdi-timer"
                          :value="dashboard_data.stats.lsa_30_seconds_response_rate + '%'"
                          :current="dashboard_data.stats.lsa_30_seconds_response_rate"
                          :previous="dashboard_data_prev.stats.lsa_30_seconds_response_rate"
                          :change="comparisons.lsa_30_seconds_response_rate"
                        />

                        <StatCard
                          title="Message Response Time"
                          icon="mdi-message-clock"
                          :value="dashboard_data.stats.lsa_messages_response_rate + ' hrs'"
                          :current="dashboard_data.stats.lsa_messages_response_rate"
                          :previous="dashboard_data_prev.stats.lsa_messages_response_rate"
                          :change="comparisons.lsa_messages_response_rate"
                          reverse
                        /> -->
                        <!-- <StatCard
                          title="Impressions"
                          icon="mdi-eye"
                          :value="dashboard_data.stats.total_impressions.toLocaleString()"
                          :current="dashboard_data.stats.total_impressions"
                          :previous="dashboard_data_prev.stats.total_impressions"
                          :change="comparisons.total_impressions"
                        />

                        <StatCard
                          title="Clicks"
                          icon="mdi-mouse"
                          :value="dashboard_data.stats.total_clicks.toLocaleString()"
                          :current="dashboard_data.stats.total_clicks"
                          :previous="dashboard_data_prev.stats.total_clicks"
                          :change="comparisons.total_clicks"
                        />

                        <StatCard
                          title="Total Cost"
                          icon="mdi-currency-usd"
                          :value="'$' + dashboard_data.stats.total_cost.toLocaleString()"
                          :current="dashboard_data.stats.total_cost"
                          :previous="dashboard_data_prev.stats.total_cost"
                          :change="comparisons.total_cost"
                        /> -->
                      </div>
                    </section>

                  </div>

              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels v-model="panel" accordion flat dense>
              <v-expansion-panel>
              <v-expansion-panel-header>Metrics Over Time</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <div class="-mr-4">
                  <div class="dashboard-box stats-box w-full p-3">
                    
                    <div v-if="!loading && dashboard_data" class="flex flex-row flex-wrap mt-5">
                      <div class="dashboard-box stats-box w-full mb-4 pr-0 mb-5">
                          <v-card
                            class="pa-2"
                            tile
                          >
                            <div class="pl-3 pt-3">
                              <div class="-mt-5 -ml-4 -mb-2">
                                  <apexchart
                                      :options="lineChartMetricsOptions"
                                      :series="lineChartMetricsSeries"
                                      type="line"
                                      height="375"
                                      ref="apexChart"
                                  />

                                  <div class="custom-legend centered">
                                      <div
                                          v-for="item in legendItems"
                                          :key="item.name"
                                          class="custom-legend-item"
                                          :class="{
                                            disabled: item.disabled,
                                            dimmed: hoveredLegend && hoveredLegend !== item.name
                                          }"
                                          @mouseover="handleLegendHover(item)"
                                          @mouseleave="handleLegendLeave"
                                          @click="toggleSeries(item)"
                                        >
                                        <v-tooltip top color="primary">
                                          <template #activator="{ on, attrs }">
                                            <div class="legend-content" v-bind="attrs" v-on="on">
                                              <span
                                                class="legend-dot"
                                                :style="{ backgroundColor: item.color }"
                                              ></span>
                                              <span class="legend-label">{{ item.name }}</span>
                                            </div>
                                          </template>
                                          <span>{{ item.description }}</span>
                                        </v-tooltip>
                                      </div>
                                    </div>
                              </div>
                            </div>
                          </v-card>
                      </div>
                    </div>

                  </div>
                  </div>
              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>

            <div class="dashboard-box">
                <v-card class="pa-2" tile>
                    <v-skeleton-loader v-if="loadingMessages" type="article, article, article"></v-skeleton-loader>

                    <div v-if="!loadingMessages" class="p-3">
                        <div v-if="messages.length == 0">
                            <br/><br/><br/><br/>
                            <div class="dashboard-box-iconsquare">
                                <div class="dashboard-box-icon-background"></div>
                                <div class="dashboard-box-icon">
                                    <i class="mdi mdi-phone"></i>
                                </div>
                            </div>
                            <div style="text-align: center;">
                                <div class="pt-2 pb-2">
                                    <strong>No Leads</strong>
                                </div>

                                <div class="text-sm mb-4 text-gray-600">
                                    No leads found for the given period. Refine your search or wait until new leads come in.
                                </div>
                                <br/>
                            </div>
                            <br/><br/><br/><br/><br/>
                        </div>

                        <div v-else style="clear: both; padding-top: 0px;">

                            <div class="mb-3 -mt-1">
                              <div class="float-left">
                                <span style="font-size:13px;color:#555;">
                                  <span style="background:#FFF7CC;border:1px solid #E6D98A;padding:6px 6px; width: 100px; border-radius:3px;margin-right:6px;">
                                    Yellow Highlighted Leads - New leads from the last 2 weeks
                                  </span>
                                </span>
                              </div>

                              <div class="legend-items float-right pl-5">
                                <div
                                  v-for="item in legend"
                                  :key="item.value"
                                  class="legend-item"
                                >
                                  <span
                                    class="legend-badge"
                                    :class="item.class"
                                  >
                                    {{ item.value }}
                                  </span>
                                  <span class="legend-label">
                                    {{ item.label }}
                                  </span>
                                </div>
                              </div>

                                <div v-if="me" style="float: right; font-size: 12px; line-height: 20px; margin-top: 5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="downloadCsv">
                                        <i class="mdi mdi-file-delimited-outline"></i> Download CSV
                                    </div>
                                </div>

                                <div v-if="me" v-show="!isAccelerate()" style="float: right; font-size: 12px; line-height: 20px; margin-top: 5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="getMonthlyReport">
                                        <i class="mdi mdi-file-outline"></i> Open Report in Browser
                                    </div>
                                </div>

                                <div v-if="me" v-show="!isAccelerate()" style="float: right; font-size: 12px; line-height: 20px; margin-top: 5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="sendMonthlyReport">
                                        <i class="mdi mdi-email"></i> Send Monthly Report
                                    </div>
                                </div>

                              <div style="clear: both;"></div>

                                <div style="float: left; padding-top: 15px;" v-show="selected.length > 0">
                                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="trainAgentWithSelectedCalls();">
                                        Train Agent with selected calls
                                    </button>
                                </div>

                              <div style="clear: both;"></div>
                            </div>

                            <!-- REVAMP: responsive lead list (cards) + details modal (no horizontal scrolling) -->
                            <div class="rg-lead-list" v-if="!loadingMessages">
                                <div
                                  v-for="item in messages"
                                  :key="item.id"

                                  class="rg-lead-card" 

                                  :class="[
                                      getRowClass(item),
                                      (activeLead && activeLead.id === item.id) ? 'is-active' : '',
                                      { 'lead--checked': !!item.checked_at }
                                    ]"
                                  role="button"
                                  tabindex="0"
                                  @click="openLeadDialog(item)"
                                  @keydown.enter.prevent="openLeadDialog(item)"
                                  @keydown.space.prevent="openLeadDialog(item)"

	                              v-bind:data-lead-id="item.id"
                                >
                                    <div class="rg-lead-card__left">
                                        <div class="">

                                            <div class="float-right">
	                                            <span class="rg-muted">{{ displayTimestamp(item.lead_creation_date) }}</span>


	                                            <div v-if="item.is_lsa_booked" class="rg-pill rg-pill--soft">Booked</div>
	                                            <div v-if="item.is_new_lead" class="rg-pill rg-pill--warn">New</div>
	                                        </div>

	                                        <i :class="leadTypeIcon(item)" class="lead-type-icon"></i>

                                            <span v-if="item.customer_name">{{ item.customer_name }} - </span>
                                            <span v-if="item.job_type">{{ item.job_type }} - </span>
                                            <span>{{ item.tracking_number || item.customer_phone_number || item.customer_name || 'Unknown customer' }}</span>

                                            &nbsp;&nbsp;&nbsp;

                                            <v-tooltip v-for="p in normalizedProviders(item)" :key="p.key" top color="primary">
                                                <template #activator="{ on, attrs }">
                                                <img
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  :src="p.src"
                                                  :alt="p.title"
                                                  class="rg-channel-icon"
                                                  :style="'cursor: initial;' + ((p.title == 'This is a call that we responded to using AI' || p.title == 'This is a Web Chat conversation') ? 'width: 52px; height: 52px; margin-left: -10px;' : '')"
                                                />
                                                </template>
                                                <span>{{ p.title }}</span>
                                            </v-tooltip>

                                            <v-tooltip v-if="item.sources.indexOf('bland') == -1 && item.sources.indexOf('web') == -1 && item.sources.indexOf('lead_form') == -1" top color="primary">
                                                <template #activator="{ on, attrs }">
                                                    <i class="mdi mdi-account" v-bind="attrs" v-on="on" :style="'cursor: initial; font-size: 33px; color: #807d7d; margin-top: 4px;'"></i>
                                                </template>
                                                <span>This is a lead that was answered by a human</span>
                                            </v-tooltip>

                                            <v-tooltip v-if="item.sources.indexOf('web') != -1" top color="primary">
                                                <template #activator="{ on, attrs }">
                                                    <i class="mdi mdi-web" v-bind="attrs" v-on="on" :style="'cursor: initial; font-size: 23px; color: #807d7d; margin-top: 4px;'"></i>
                                                </template>
                                                <span>This is a conversation that was answered by our AI Chat Widget</span>
                                            </v-tooltip>
                                        </div>

                                        <div class="text-sm">
                                            Lead ID: <strong>{{ item.lead_id || item.id }}</strong>
                                        </div>

                                        <div class="rg-lead-metrics">
                                            <span v-if="item.charge_status == 'CHARGED'">
	                                            <span v-if="item.dispute_status == 'APPROVED'">
	                                                <v-chip
	                                                    small
	                                                    color="green lighten-4"
	                                                    text-color="green"
	                                                >
	                                                    Credited
	                                                </v-chip>
	                                            </span>
	                                            <span v-else>
	                                                <v-chip
	                                                    small
	                                                    color="blue lighten-4"
	                                                    text-color="blue"
	                                                >
	                                                    Charged
	                                                </v-chip>
	                                            </span>
	                                        </span>
	                                        <span v-else>
	                                            <v-chip
	                                                small
	                                                color="gray lighten-5"
	                                                text-color="gray"
	                                            >
	                                                Not Charged
	                                            </v-chip>
	                                        </span>

                                            <span v-if="getUUID() == '8392ce47-b5e0-440d-b58e-5b6b69492553'">
                                                <span v-if="item.lead_stage == 'Converted'">
                                                    <v-chip
                                                        small
                                                        color="green lighten-4"
                                                        text-color="green"
                                                    >
                                                        Converted
                                                    </v-chip>
                                                </span>
                                                <span v-else-if="item.lead_stage == 'Estimate Sent'">
                                                    <v-chip
                                                        small
                                                        color="blue lighten-4"
                                                        text-color="blue"
                                                    >
                                                        Estimate Sent
                                                    </v-chip>
                                                </span>
                                                <span v-else>
                                                    <v-chip
                                                        small
                                                        color="orange lighten-4"
                                                        text-color="orange"
                                                    >
                                                        Lead Captured
                                                    </v-chip>
                                                </span>
                                            </span>

                                            <span class="rg-metric" v-if="item.rated_at">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-chip
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      :color="getSatisfactionColor(convertSatisfactionToNumber(item.satisfaction))"
                                                      dark
                                                      class="font-weight-black"
                                                      style="height: 28px; padding: 0 10px; font-size: 13px;"
                                                    >
                                                      <span style="font-weight: 900; font-size: 13px;">
                                                        {{ convertSatisfactionToNumber(item.satisfaction) }}
                                                      </span>
                                                    </v-chip>
                                                  </template>
                                                  <span class="tooltip-text">
                                                    Google LSA Rating Notes: {{ item.summary || item.additional_comments }}
                                                  </span>
                                                </v-tooltip>
                                                <span class="score-label" style="margin-left:10px;">
                                                  <strong>{{ satisfactionLabelByTexts(item.satisfaction) }}</strong>
                                                </span>
                                            </span>
                                            <span class="rg-muted" v-else>Not Rated</span>

                                            <span class="rg-metric" v-if="item.intake_performance" style="margin-left: 10px;">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-chip
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      small
                                                      :color="getSatisfactionColor(item.intake_performance.rating)"
                                                      dark
                                                      class="font-weight-bold"
                                                      style="height: 28px; padding: 0 10px; font-size: 13px;"
                                                    >
                                                      <span style="font-weight: 900; font-size: 13px;">{{ item.intake_performance.rating }}</span>
                                                    </v-chip>
                                                  </template>
                                                  <span class="tooltip-text">{{ item.intake_performance.explanation }}</span>
                                                </v-tooltip>
                                                <span class="rg-muted" style="margin-left:6px;">IP</span>
                                            </span>

                                            <span class="rg-metric" v-if="item.ai_performance" style="margin-left: 10px;">
                                            	&nbsp;&nbsp;&nbsp;
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-chip
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      small
                                                      :color="getSatisfactionColor(item.ai_performance.rating)"
                                                      dark
                                                      class="font-weight-bold"
                                                      style="height: 28px; padding: 0 10px; font-size: 13px;"
                                                    >
                                                      <span style="font-weight: 900; font-size: 13px;">{{ item.ai_performance.rating }}</span>
                                                    </v-chip>
                                                  </template>
                                                  <span class="tooltip-text">AI Performance: {{ item.ai_performance.explanation }}</span>
                                                </v-tooltip>
                                                <!-- <span class="rg-muted" style="margin-left:6px;">AIP</span> -->
                                            </span>
                                        </div>
                                    </div>

                                    <div class="rg-lead-card__right" @click.stop>
                                        <div class="rg-channels" style="position: relative;">

                                            <span v-if="item.notes.length > 0" style="width: 16px;
                                                height: 14px;
                                                line-height: 15px;
                                                font-size: 9px;
                                                background: rgb(255, 112, 67);
                                                color: rgb(255, 255, 255);
                                                padding: 0px !important;
                                                border-radius: 100%;
                                                position: absolute;
                                                font-weight: 600;
                                                text-align: center; position: absolute; top: 0px; right: -2px;">{{ item.notes.length }}</span>

                                            <!-- <button class="rg-link" type="button" @click.stop="openPhotosDialog(item)" title="Photos">
                                                <i class="mdi mdi-image-multiple-outline" style="font-size: 18px;"></i>
                                            </button> -->

                                            <br />

                                            <!-- CHECK / UNCHECK -->
                                            <button
                                              class="rg-link"
                                              type="button"
                                              @click.stop="toggleChecked(item)"
                                              :title="item.checked_at ? 'Uncheck lead' : 'Mark as checked'"
                                              style="margin-top: -8px;"
                                            >
                                              <i
                                                class="mdi"
                                                :class="item.checked_at ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'"
                                                style="font-size: 18px;"
                                              ></i>
                                            </button>

                                            <!-- STAR / UNSTAR -->
                                            <button
                                              class="rg-link"
                                              type="button"
                                              @click.stop="toggleStar(item)"
                                              :title="item.starred_at ? 'Unimportant lead' : 'Important lead'"
                                              style="margin-top: -8px;"
                                            >
                                              <i
                                                class="mdi"
                                                :class="[
                                                    item.starred_at ? 'mdi-star' : 'mdi-star-outline',
                                                    { 'starred-icon': item.starred_at }
                                                ]"
                                                style="font-size: 18px;"
                                              ></i>
                                            </button>
                                            

                                            <button class="rg-link" type="button" @click.stop="activeLead = item; show_notes_dialog = true;" title="Notes" style="margin-top: -8px;">
                                                <i class="mdi mdi-note-text-outline" style="font-size: 18px;"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="messages.length === 0" class="rg-empty">
                                    No leads found.
                                </div>
                            </div>

                            <!-- Details dialog -->
                            <div v-if="leadDialogOpen" class="rg-modal-overlay" @click.self="closeLeadDialog" :key="showFullactiveLeadKey">
                                <div class="rg-modal" role="dialog" aria-modal="true">
                                    <div class="rg-modal__header">
                                        <div>
                                            <div class="rg-modal__title">
                                                <span v-if="activeLead && activeLead.job_type">{{ activeLead.job_type }} - </span>
                                                <span>{{ (activeLead && (activeLead.tracking_number || activeLead.customer_phone_number || activeLead.customer_name)) || 'Lead details' }}</span>
                                            </div>
                                            <div class="rg-modal__subtitle" v-if="activeLead">
                                                <span class="rg-muted">{{ displayTimestamp(activeLead.lead_creation_date) }}</span>
                                                <span class="rg-dot">•</span>
                                                <span class="rg-muted">Lead ID: {{ activeLead.lead_id || activeLead.id }}</span>
                                            </div>
                                        </div>

                                        <button class="rg-close" type="button" @click="closeLeadDialog" aria-label="Close">
                                            <i class="mdi mdi-close"></i>
                                        </button>
                                    </div>

                                    <div class="rg-modal__tabs">
                                        <button class="rg-tab" :class="{active: leadDialogTab==='overview'}" type="button" @click="leadDialogTab='overview'">Overview</button>
                                        <button class="rg-tab" :class="{active: leadDialogTab==='notes'}" type="button" @click="leadDialogTab='notes'">Notes</button>
                                        <button class="rg-tab" :class="{active: leadDialogTab==='transcripts'}" type="button" @click="leadDialogTab='transcripts'">Transcript</button>
                                        <button class="rg-tab" :class="{active: leadDialogTab==='photos'}" type="button" @click="leadDialogTab='photos'">Photos</button>
                                    </div>

                                    <div class="rg-modal__body" v-if="activeLead">
                                        <!-- Overview -->
                                        <div v-show="leadDialogTab==='overview'" class="rg-grid">
                                            <div class="rg-kv">
                                                <div class="rg-k">Name</div>
                                                <div class="rg-v">
                                                    <div :class="'lsa-show-customer-name lsa-show-customer-name-' + activeLead.id">
                                                        <a href="javascript: void(0);" @click="showEditCustomerName(activeLead)">{{ activeLead.customer_name || "Add Name" }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                                    </div>
                                                    <div :class="'lsa-edit-customer-name lsa-edit-customer-name-' + activeLead.id" style="display: none; position: relative; width: 140px;">
                                                        <input type="text" :value="activeLead.customer_name" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                                        <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                            <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editCustomerName(activeLead)"><i class="mdi mdi-check"></i></a>
                                                            <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditCustomerName(activeLead)"><i class="mdi mdi-close"></i></a>
                                                        </div>
                                                        <div style="clear: both;"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Phone Number</div>
                                                <div class="rg-v">
                                                    <span>{{ activeLead.tracking_number || activeLead.customer_phone_number || activeLead.customer_name || 'Unknown' }}</span>
                                                </div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Email</div>
                                                <div class="rg-v">{{ activeLead.customer_email || "N/A" }}</div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Address</div>
                                                <div class="rg-v">{{ activeLead.address || "N/A" }}</div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Charge</div>
                                                <div class="rg-v">
                                                    <span v-if="activeLead.charge_status == 'CHARGED'">
			                                            <span v-if="activeLead.dispute_status == 'APPROVED'">
			                                                <v-chip
			                                                    small
			                                                    color="green lighten-4"
			                                                    text-color="green lighten-1"
			                                                >
			                                                    Credited
			                                                </v-chip>
			                                            </span>
			                                            <span v-else>
			                                                <v-chip
			                                                    small
			                                                    color="blue lighten-4"
			                                                    text-color="blue lighten-1"
			                                                >
			                                                    Charged
			                                                </v-chip>
			                                            </span>
			                                        </span>
			                                        <span v-else>
			                                            <v-chip
			                                                small
			                                                color="gray lighten-5"
			                                                text-color="gray lighten-1"
			                                            >
			                                                Not Charged
			                                            </v-chip>
			                                        </span>
                                                </div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Lead type</div>
                                                <div class="rg-v">{{ leadTypeLabel(activeLead) }}</div>
                                            </div>

                                            <div class="rg-kv" v-if="me">
                                                <div class="rg-k">Tags</div>
                                                <div class="rg-v">
                                                	<div v-if="me" class="rg-tags" @click.stop style="margin-top:8px;">
		                                                <span v-for="(tag, index_tag) in activeLead.tag" :key="'tag-'+index_tag" class="pr-2 pb-1 inline-block">
		                                                  <v-chip v-if="tag == 0" class="mb-1 dark">
		                                                    <span style="font-size: 12px;">Not Set</span>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 1" color="#3EBB80">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 2" color="#44468F">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 3" color="#FFB443" v-show="!isOnlyAi()">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 4" color="#2477F6" v-show="!isOnlyAi()">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 5" color="#FF3349">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Not Interested</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 6" color="#157B79">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Quote Requested</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 7" color="#6E62B5">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Duplicate Call</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 8" color="#E67B20">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">AI Test Call</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1" v-if="tag == 9" color="#4FBFA9">
		                                                    <span style="font-size: 12px; color: #FFFFFF;">Call Back Later</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>

		                                                  <v-chip class="mb-1"
		                                                    v-if="tag != 0 && tag != 1 && tag != 2 && tag != 3 && tag != 4 && tag != 5 && tag != 6 && tag != 7 && tag != 8 && tag != 9
		                                                      && tag != 'Booked to Estimate'
		                                                      && tag != 'Booked to Service'
		                                                      && tag != 'Booked for Appointment'
		                                                      && tag != 'Complete'
		                                                      && tag != 'Incomplete'
		                                                      && tag != 'Cancelled'
		                                                      && tag != 'Duplicate Call'
		                                                      && tag != 'AI Test Call'
		                                                    "
		                                                    :color="getCustomTagColor(tag)"
		                                                  >
		                                                    <span style="font-size: 12px; color: #FFFFFF;">{{ tag }}</span>
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click.stop="removeTag(activeLead, tag);">mdi-delete-outline</v-icon>
		                                                  </v-chip>
		                                                </span>

		                                                <v-menu bottom right nudge-bottom="25">
		                                                  <template v-slot:activator="{ on, attrs }">
		                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
		                                                  </template>
		                                                  <v-list class="table-menu-actions p-2" style="max-height: 320px; overflow-y: auto;">
		                                                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #44468F;" @click="setTag(activeLead, 2);">Missed Call</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #FFB443;" @click="setTag(activeLead, 3);">Opportunity</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #2477F6;" @click="setTag(activeLead, 4);">Meeting Scheduled</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #FF3349;" @click="setTag(activeLead, 5);">Not Interested</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #3EBB80;" @click="setTag(activeLead, 1);">Existing Customer</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #157B79;" @click="setTag(activeLead, 6);">Quote Requested</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #6E62B5;" @click="setTag(activeLead, 7);">Duplicate Call</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #E67B20;" @click="setTag(activeLead, 8);">AI Test Call</span></a></v-list-item-title></v-list-item>
		                                                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);"><span class="table-menu-action-icon" style="color: #4FBFA9;" @click="setTag(activeLead, 9);">Call Back Later</span></a></v-list-item-title></v-list-item>
		                                                  </v-list>
		                                                </v-menu>
		                                            </div>
                                                </div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Notes</div>
                                                <div class="rg-v">
                                                    <div class="rg-note-actions">

                                                        <div style="font-size: 12px; padding-bottom: 10px;">
                                                            <div v-if="activeLead.notes.length == 0">
                                                                No notes found.
                                                            </div>

                                                            <div v-else>
                                                                <div v-for="(note, note_index) in activeLead.notes" style="clear: both; padding-bottom: 10px;">
                                                                    <div style="float: left; width: calc(100% - 220px);">
                                                                        {{ note.note }}
                                                                    </div>

                                                                    <div style="float: right; width: 200px; text-align: right;">
                                                                        [{{ formatDate(note.timestamp) }}]

                                                                        &nbsp;&nbsp;

                                                                        <a href="javascript: void(0);"><i class="mdi mdi-delete-outline" style="color: red;" @click="deleteNote(note_index)"></i></a>
                                                                    </div>

                                                                    <div style='clear: both;'></div>
                                                                </div>

                                                                <div style='clear: both;'></div>
                                                            </div>
                                                        </div>

                                                        <v-expansion-panels v-model="panel" accordion flat dense>
                                                            <v-expansion-panel>
                                                              <v-expansion-panel-header>Add Note</v-expansion-panel-header>
                                                              <v-expansion-panel-content>
                                                                <v-textarea
                                                                    clearable
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    label="Enter Note"
                                                                    v-model="new_note"

                                                                    class="white border border-white mt-2"
                                                                ></v-textarea>

                                                                <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingNote}" @click="saveNote">
                                                                    SAVE
                                                                </button>

                                                                <div class="clearfix"></div>

                                                              </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Google LSA rating</div>
                                                <div class="rg-v">
                                                    <span v-if="activeLead.rated_at" class="rg-metric">
                                                        <v-tooltip bottom content-class="intake-tooltip">
                                                              <template v-slot:activator="{ on, attrs }">
                                                                <v-chip
                                                                  v-bind="attrs"
                                                                  v-on="on"
                                                                  :color="getSatisfactionColor(convertSatisfactionToNumber(activeLead.satisfaction))"
                                                                  dark
                                                                  class="font-weight-black"
                                                                  style="height: 28px; padding: 0 10px; font-size: 13px;"
                                                                >
                                                                  <span style="font-weight: 900; font-size: 13px;">
                                                                    {{ convertSatisfactionToNumber(activeLead.satisfaction) }}
                                                                  </span>
                                                                </v-chip>
                                                              </template>
                                                              <span class="tooltip-text">
                                                                Google LSA Rating Notes: {{ activeLead.summary || activeLead.additional_comments }}
                                                              </span>
                                                            </v-tooltip>
                                                            <span class="score-label" style="margin-left:10px;">
                                                              <strong>{{ satisfactionLabelByTexts(activeLead.satisfaction) }}</strong>
                                                            </span>
                                                    </span>
                                                    <span v-else class="rg-muted">Not Rated</span>
                                                </div>
                                            </div>

                                            <div class="rg-kv" v-if="me">
                                                <div class="rg-k">Value</div>
                                                <div class="rg-v">
                                                    <div :class="'lsa-show-value lsa-show-value-' + activeLead.id">
                                                        <a href="javascript: void(0);" @click="showEditValue(activeLead)">${{ activeLead.value }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                                    </div>
                                                    <div :class="'lsa-edit-value lsa-edit-value-' + activeLead.id" style="display: none; position: relative; width: 140px;">
                                                        <input type="text" :value="((activeLead.value > 0) ? activeLead.value : me.settings.customer_value)" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                                        <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                            <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editValue(activeLead)"><i class="mdi mdi-check"></i></a>
                                                            <a href="javascript: void(0);" style="color: #E53F71 !important;" @click="cancelEditValue(activeLead)"><i class="mdi mdi-close"></i></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="rg-kv">
                                                <div class="rg-k">Channels</div>
                                                <div class="rg-v rg-channels-inline">
                                                    <span v-for="p in normalizedProviders(activeLead)" :key="p.key" class="rg-pill rg-pill--soft">{{ providerLabel(p.key) }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Notes -->
                                        <div v-show="leadDialogTab==='notes'" class="rg-notes">
                                            <div class="rg-note-block">
                                                <div class="rg-k">Google LSA rating notes</div>
                                                <div class="rg-note">{{ activeLead.summary || activeLead.additional_comments }}</div>
                                            </div>

                                            <div class="rg-note-block">
                                                <div class="rg-k">Intake performance (IP) notes</div>
                                                <div class="rg-note">{{ (activeLead.intake_performance && activeLead.intake_performance.explanation) ? activeLead.intake_performance.explanation : 'N/A' }}</div>
                                            </div>

                                            <div class="rg-note-block">
                                                <div class="rg-k">AI performance (AIP) notes</div>
                                                <div class="rg-note">{{ (activeLead.ai_performance && activeLead.ai_performance.explanation) ? activeLead.ai_performance.explanation : 'N/A' }}</div>
                                            </div>
                                        </div>

                                        <!-- Transcripts -->
                                        <div v-show="leadDialogTab==='transcripts'" class="rg-transcripts">
                                            <!-- <div class="rg-channel-tabs">
                                                <button
                                                  v-for="p in normalizedProviders(activeLead)"
                                                  :key="p.key"
                                                  type="button"
                                                  class="rg-chip-tab"
                                                  :class="{active: activeLeadChannel===p.key}"
                                                  @click="activeLeadChannel = p.key"
                                                >
                                                    {{ providerLabel(p.key) }}
                                                </button>

                                                <button
                                                  v-if="activeLead.sources && activeLead.sources.indexOf('web') != -1"
                                                  type="button"
                                                  class="rg-chip-tab"
                                                  :class="{active: activeLeadChannel==='web'}"
                                                  @click="activeLeadChannel='web'"
                                                >
                                                    Web Chat
                                                </button>
                                            </div> -->

                                            <div class="rg-transcript-actions">
                        <p v-if="transcriptError" role="alert" class="rg-muted">{{ transcriptError }}</p>
                        <button type="button" class="rg-tab" :disabled="transcriptsLoading" @click="loadActiveTranscript({ force: true })">Reload transcript</button>

                                                <div v-if="transcriptsLoading" class="py-4">
                                                    <v-skeleton-loader type="article, article"></v-skeleton-loader>
                                                </div>

                                                <div v-else>

                                                    <!-- Web chat -->
                                                    <div v-if="activeLead.sources.indexOf('web') != -1">
                                                        <div class="rg-k mb-2">Web chat conversation</div>

                                                        <div v-if="!transcriptData.web || !transcriptData.web.messages || transcriptData.web.messages.length===0" class="rg-muted">
                                                            No conversation found.
                                                        </div>

                                                        <div v-else class="rg-transcript-thread">
                                                            <div v-for="(msg, idx) in transcriptData.web.messages" :key="'webmsg-'+idx" class="rg-msg" :class="msg.sender==='human' ? 'is-human' : 'is-bot'">
                                                                <div class="rg-msg__meta">
                                                                    <strong>{{ (msg.sender==='human' || msg.role==='user') ? 'Customer' : 'Assistant' }}</strong>
                                                                    <span v-if="msg.timestamp" class="rg-muted"> • {{ displayTimestamp(msg.timestamp) }}</span>
                                                                </div>
                                                                <div class="rg-msg__text">{{ msg.message || msg.text || msg.text || msg.content }}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- AI / Bland transcript -->
                                                    <div v-else-if="activeLead.sources.indexOf('bland') != -1">
                                                        <div v-if="activeLead.bland_recording_url" class="mb-4">
                                                            <div class="rg-k mb-1">Recording</div>
                                                            <audio controls :src="activeLead.bland_recording_url" style="width:100%;"></audio>
                                                        </div>

                                                        <div class="rg-k mb-2">Transcript</div>

                                                        <div v-if="!transcriptData.bland || !transcriptData.bland.messages || transcriptData.bland.messages.length===0" class="rg-muted">
                                                            No transcript found.
                                                        </div>

                                                        <div v-else class="rg-transcript-thread">
                                                            <div v-for="(msg, idx) in transcriptData.bland.messages" :key="'bmsg-'+idx" class="rg-msg" :class="msg.sender==='human' ? 'is-human' : 'is-bot'">
                                                                <div class="rg-msg__meta" v-show="msg.message || msg.text || msg.content">
                                                                    <strong>{{ (msg.sender==='human' || msg.sender==='user' || msg.role==='user') ? 'Customer' : 'Assistant' }}</strong>
                                                                    <span v-if="msg.timestamp" class="rg-muted"> • {{ displayTimestamp(msg.timestamp) }}</span>
                                                                </div>
                                                                <div class="rg-msg__text">{{ msg.message || msg.text || msg.content }}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- LSA -->
                                                    <div v-else-if="activeLead.sources.indexOf('lsa') != -1">
                                                        <div class="rg-k mb-2">LSA</div>

                                                        <div v-if="activeLead.lead_type === 'PHONE_CALL'">
                                                            <div v-if="(transcriptData.lsa_recordings || []).length===0" class="rg-muted">No recordings found.</div>
                                                            <div v-else class="rg-audio-list">
                                                                <div v-for="(src, i) in transcriptData.lsa_recordings" :key="'lsa-audio-'+i" class="mb-4">
                                                                    <audio controls :src="src" style="width:100%;"></audio>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div v-else>
                                                            <div v-if="(transcriptData.lsa_messages || []).length===0" class="rg-muted">No messages found.</div>
                                                            <div v-else class="rg-transcript-thread">
                                                                <div v-for="(msg, idx) in transcriptData.lsa_messages" :key="'lsamsg-'+idx" class="rg-msg" :class="msg.sender==='human' ? 'is-human' : 'is-bot'">
                                                                    <div class="rg-msg__meta" v-sow="msg.message || msg.text || msg.content">
                                                                        <strong>{{ (msg.sender==='human' || msg.role==='user') ? 'Customer' : 'Assistant' }}</strong>
                                                                        <span v-if="msg.timestamp" class="rg-muted"> • {{ displayTimestamp(msg.timestamp) }}</span>
                                                                    </div>
                                                                    <div class="rg-msg__text">{{ msg.message || msg.text || msg.content }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-else class="rg-muted">No transcript view configured for this channel.</div>
                                                </div>
                                            </div>

                                        </div>

                                        <div v-show="leadDialogTab==='photos'" class="rg-photos">
                                        	<!-- NO PHOTOS -->
					                        <div v-if="photos.length == 0" style="font-size: 13px;">
					                            No photos uploaded.
					                        </div>

					                        <!-- PHOTO GRID -->
					                        <div v-else class="grid grid-cols-2 md:grid-cols-3 gap-4">
					                            <div v-for="(photo, index) in photos" :key="index" style="position: relative;">
					                                
					                                <img :src="photo"
					                                     style="width: 100%; height: 150px; object-fit: cover; border-radius: 6px;" />

					                                <button @click="removePhoto(index)"
					                                        style="position: absolute; top: 5px; right: 5px; background: red; color: white; border: none; border-radius: 50%; width: 25px; height: 25px;">
					                                    ✕
					                                </button>

					                            </div>
					                        </div>

					                        <!-- FILE INPUT -->
					                        <div class="mt-4">
					                            <input type="file"
					                                   accept="image/*"
					                                   @change="handlePhotoUpload"
					                                   multiple :disabled="uploading" />

					                            <div v-if="uploading" class="pt-3">Uploading... please wait</div>
					                        </div>
                                        </div>
                                    </div>

                                    <div class="rg-modal__footer" v-if="activeLead">
                                        <button class="rg-secondary" type="button" @click="closeLeadDialog">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import $ from 'jquery';
import axios from 'axios'
import moment from 'moment'
import StatCard from  "@/views/panel/Call/StatCard.vue"

export default {
    components: {
        StatCard
    },
    computed: {
      ...mapState({
          me: state => state.me.me
      }),
      headers() {
        return [
            { text: 'Customer', value: 'customer_name', width: 200, show: true },
            { text: 'Channels', value: 'sources', show: true },
            { text: 'Lead Received', value: 'lead_creation_date', show: true },
            { text: 'Charge Status', value: 'charge_status', width: 170, show: true },
            { text: 'Google LSA Rating', value: 'ai_rating', align: 'start', sortable: false, width: 200, show: true },
            { text: 'Google LSA Rating Notes', value: 'lead_quality_notes', align: 'start', width: 200, sortable: false, show: true },
            { text: 'IP', value: 'intake_performance', align: 'start', sortable: false, show: true },
            { text: 'Intake Performance (IP) Notes', value: 'intake_performance_notes', align: 'start', sortable: false, width: 220, show: true },
            { text: 'AIP', value: 'ai_performance', align: 'start', sortable: false, show: true },
            { text: 'AI Performance (AIP) Notes', value: 'ai_performance_notes', align: 'start', sortable: false, width: 200, show: true },
            { text: 'Tags', value: 'tag', width: 130, show: this.me },
            { text: 'Value', value: 'value', width: 100, show: this.me },
            { text: 'Actions', value: 'id', width: 100, show: this.me }
        ].filter(h => h.show)
      }
    },
    data() {
        return {
            messages: [],
            loading: true,
            loadingMessages: true,

            selected_frequency: 'Frequency: Auto',

            show_picker: false,
            date_filter: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],

            all_time: 0,

            selected_date_text: "Last 30 days",

            new_note: "",
            show_notes_dialog: false,
            notes_lead: null,
            savingNote: false,

            showBlandRecording: false,
            loading_bland_recording: true,
            bland_recording_data: {},

            showLsaRecordings: false,
            loading_lsa_recordings: true,
            lsa_recording_data: {},

            showLsaMessages: false,
            loading_lsa_messages: true,
            lsa_messages_displayed: [],
            lsa_item: null,

            cutoffDate: null,

            selected: [],

            company_name: "",
            uuid: "",
            ai_started_on: "",

            survey_started_on: "",

            selectedMonth: '',
            months: [],

            startDate: '', // Start date of the selected month
            endDate: '',   // End date of the selected month

            dashboard_data: [],
            dashboard_data_prev: [],
            comparisons: {},

            custom_tags: [],
            custom_statuses: [],

            aiSuggestionById: {}, // { [leadId]: { satisfaction, reason, comment, satisfactionLabel, reasonLabel } }
            aiLoadingById: {},    // { [leadId]: boolean }
            aiLoadingInakePerformanceById: {},    // { [leadId]: boolean }
            aiLoadingAiPerformanceById: {},    // { [leadId]: boolean }
            aiLoadingLeadQualityPerformanceById: {},    // { [leadId]: boolean }

            tags_items: [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 3,
                    text: 'Opportunity'
                },{
                    index: 4,
                    text: 'Meeting Scheduled'
                },{
                    index: 5,
                    text: 'Became Customer'
                },{
                    index: 'Signed',
                    text: 'Signed'
                }
                ,{
                    index: 'Booked for Consultation',
                    text: 'Booked for Consultation'
                }
                ,{
                    index: 'Declined/Not a lead',
                    text: 'Declined/Not a lead'
                }
                ,{
                    index: 'Wrong Number',
                    text: 'Wrong Number'
                }
                ,{
                    index: 'No Response',
                    text: 'No Response'
                }
                ,{
                    index: 'Existing Client',
                    text: 'Existing Client'
                }
                ,{
                    index: 'Failed Sign Up',
                    text: 'Failed Sign Up'
                }
                ,{
                    index: 'Following Up/Working on this one',
                    text: 'Following Up/Working on this one'
                }
                ,{
                    index: 'E-Doc sent not signed',
                    text: 'E-Doc sent not signed'
                }
                ,{
                    index: 'Booked to Service',
                    text: 'Booked to Service'
                }
                ,{
                    index: 'Booked for Appointment',
                    text: 'Booked for Appointment'
                }
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                }, {
                    index: 'Duplicate Call',
                    text: 'Duplicate Call'
                },
            ],

            lineChartMetricsOptions: {
              colors: ["rgb(0, 143, 251)", "rgb(254, 176, 25)", "#16a34a", "rgb(255, 69, 96)", "rgb(119, 93, 208)", "#4284C1", "rgb(0, 227, 150)", "rgb(56, 193, 167)"],
              chart: {
                  id: "line-chart",
                  toolbar: {
                      show: false
                  }
              },
              legend: {
                  show: false
                },
              xaxis: {
                  categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                  ],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: [
                {
                  opposite: false,
                  labels: {
                    show: true
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                }
              ],
              stroke: {
                  curve: "smooth",
                  width: [4, 4, 4, 4, 4, 9, 4] // last line thicker
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },

              tooltip: {
                shared: true,
                intersect: false,
                y: [{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": $" + y;
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseFloat(y).toFixed(2);
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }]
              }
          },
          lineChartMetricsSeries: [
              {
                name: "Reviews",
                data: [30, 40, 25, 50, 49, 49],
              },
          ],

          legend: [
            { value: 5, label: "Very good", class: "score-1" },
            { value: 4, label: "Good", class: "score-2" },
            { value: 3, label: "Neutral", class: "score-3" },
            { value: 2, label: "Bad", class: "score-4" },
            { value: 1, label: "Very bad", class: "score-5" },
          ],

          panel: 0,
          panel2: 0,

          hoveredLegend: null,

          legendItems: [
              {
                name: "Impressions",
                color: "rgb(0, 143, 251)",
                description: "Total times your ad was shown to users.",
                disabled: false
              },
              {
                name: "Absolute Top Impressions Rate",
                color: "rgb(254, 176, 25)",
                description: "Percentage of your search ad impressions shown in the most prominent position on the page.", // from API docs :contentReference[oaicite:0]{index=0}
                disabled: false
              },
              {
                name: "Under 30s Response Rate",
                color: "#16a34a",
                description: "Percentage of how many leads were responded in under 30 seconds.", // from API docs :contentReference[oaicite:0]{index=0}
                disabled: false
              },
              {
                name: "Lead Volume",
                color: "rgb(255, 69, 96)",
                description: "The number of leads generated — typically form submissions or qualified contacts.",
                disabled: false
              },
              {
                name: "Clicks",
                color: "rgb(119, 93, 208)",
                description: "Number of times users clicked on your ad.",
                disabled: false
              },
              {
                name: "Total Cost",
                color: "#4284C1",
                description: "Total ad spend over the chosen period.",
                disabled: false
              },
              {
                name: "Lead Quality",
                color: "rgb(0, 227, 150)",
                description: "A score from 1 to 5 indicating how qualified the leads are — higher means more likely to convert.",
                disabled: false
              },
              {
                name: "Credited",
                color: "rgb(56, 193, 167)",
                description: "Leads that were originally charged but later refunded due to invalid submissions, cancellations, or quality adjustments after we started submitting your surveys.",
                disabled: false
              }
            ],

            shouldShowChatConversation: false,
            loading_chat_conversation: false,

            new_ai_message: "",
            sendingAiMessage: false,
            ai_messages_lead: null,

            savingAiFeedback: false,

            show_photos_dialog: false,
            photos: [], // array of photo URLs
            savingPhotos: false,
            lead_id: null, // set this when opening dialog

            // Lead details modal (revamp)
            leadDialogOpen: false,
            activeLead: null,
            leadDialogTab: 'overview',
            activeLeadChannel: null,

            // Inline transcript state (revamp)
            transcriptsLoading: false,
            transcriptRequestId: 0,
            transcriptError: '',
            transcriptCache: {},
            transcriptData: {
              bland: null,
              lsa_recordings: [],
              lsa_messages: [],
              web: null
            },

            uploading: false,

            showFullactiveLeadKey: 0
            
        }
    },

    methods: {
        applyDate(selected_date) {
            this.all_time = 0;
            // console.log('selected_date', selected_date);
            this.selected_date_text = selected_date;
            switch (selected_date) {
              case 'This Week':
                this.date_filter[0] = moment().startOf('week').format('YYYY-MM-DD');
                this.date_filter[1] = moment().endOf('week').format('YYYY-MM-DD');
              break;
              case 'Last Week':
                this.date_filter[0] = moment().startOf('week').subtract(7, 'days').format('YYYY-MM-DD');
                this.date_filter[1] = moment().endOf('week').subtract(7, 'days').format('YYYY-MM-DD');
              break;
              case 'This Month':
                this.date_filter[0] = moment().startOf('month').format('YYYY-MM-DD');
                this.date_filter[1] = moment().endOf('month').format('YYYY-MM-DD');
              break;
              case 'Last Month':
                this.date_filter[0] = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                this.date_filter[1] = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
              break;
              case 'Last 60 days':
                this.date_filter[0] = moment().subtract(60, 'days').format('YYYY-MM-DD');
                this.date_filter[1] = moment().format('YYYY-MM-DD');
              break;
              case 'Last 90 days':
                this.date_filter[0] = moment().subtract(90, 'days').format('YYYY-MM-DD');
                this.date_filter[1] = moment().format('YYYY-MM-DD');
              break;
              case 'This Year':
                this.date_filter[0] = moment().startOf('year').format('YYYY-MM-DD');
                this.date_filter[1] = moment().endOf('year').format('YYYY-MM-DD');
              break;
              case 'Last Year':
                this.date_filter[0] = moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD');
                this.date_filter[1] = moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD');
              break;

              case 'All Time':
                this.date_filter[0] = moment().startOf('year').subtract(10, 'years').format('YYYY-MM-DD');
                this.date_filter[1] = moment().format('YYYY-MM-DD');
                
                this.all_time = 1;
              break;
            }
            // console.log(this.date_filter);
            this.show_picker = false;
            this.getMessages();
          },

            async toggleChecked(item) {
              const prev = item.checked_at
              // optimistic UI
              item.checked_at = prev ? null : new Date().toISOString()

              try {
                const { data } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/toggle-checked`, {
                    lead_id: item.id
                }, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })
                // trust server source of truth
                item.checked_at = data.checked_at
              } catch (e) {
                item.checked_at = prev
                console.error(e)
              }
            },

            async toggleStar(item) {
              const prev = item.starred_at
              // optimistic UI
              item.starred_at = prev ? null : new Date().toISOString()

              try {
                const { data } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/toggle-starred`, {
                    lead_id: item.id
                }, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })
                item.starred_at = data.starred_at
              } catch (e) {
                item.starred_at = prev
                console.error(e)
              }
            },

    		leadTypeIcon(item) {
			  if (item.lead_type === 'PHONE_CALL') {
			    return 'mdi mdi-phone'
			  }

			  if (item.lead_type === 'MESSAGE') {
			    if (item.source && item.source.toLowerCase().includes('web')) {
			      return 'mdi mdi-chat'
			    }
			    return 'mdi mdi-message-text'
			  }

			  return 'mdi mdi-briefcase'
			},

            openLeadDialog(item, opts = {}) {
                ++this.transcriptRequestId;
                this.transcriptsLoading = false;
                this.transcriptError = '';
                this.transcriptData = { bland: null, lsa_recordings: [], lsa_messages: [], web: null };
                this.activeLead = item;

                let newTags = [];

                for (var i in this.activeLead.tag) {
                	if (this.activeLead.tag[i] != "Complete" && this.activeLead.tag[i] != "Incomplete" && this.activeLead.tag[i] != "Duplicate Call") {
                		newTags.push(this.activeLead.tag[i]);
                	}
                }

                this.activeLead.tag = newTags;

                if (this.activeLead.photos) {
                    this.photos = this.activeLead.photos.split(',')
                } else {
                    this.photos = []
                }

                this.leadDialogOpen = true;
                this.leadDialogTab = opts.tab || 'overview';

                // pick a default channel tab
                const providers = this.normalizedProviders(item) || [];
                const firstKey = (providers[0] && providers[0].key) ? providers[0].key : null;
                this.activeLeadChannel = opts.channel || firstKey || (item.sources && item.sources.indexOf('web') !== -1 ? 'web' : null);

                // lock background scroll
                document.documentElement.classList.add('rg-modal-open');
                // document.body.classList.add('rg-modal-open');
            },
            closeLeadDialog() {
                ++this.transcriptRequestId;
                this.transcriptsLoading = false;
                this.leadDialogOpen = false;
                this.activeLead = null;
                this.leadDialogTab = 'overview';
                this.activeLeadChannel = null;

                document.documentElement.classList.remove('rg-modal-open');
                // document.body.classList.remove('rg-modal-open');
            },

            async loadActiveTranscript({ force = false } = {}) {
                if (!this.activeLead || !this.activeLeadChannel) return;
                if (this.leadDialogTab !== 'transcripts') return;

                const lead = this.activeLead;
                const channel = this.activeLeadChannel;

                const requestId = ++this.transcriptRequestId;
                const isCurrent = () => requestId === this.transcriptRequestId && this.activeLead === lead && this.activeLeadChannel === channel;
                this.transcriptError = '';
                const cacheKey = `${lead.id}:${channel}`;
                if (!force && this.transcriptCache[cacheKey]) {
                    this.transcriptData = JSON.parse(JSON.stringify(this.transcriptCache[cacheKey]));
                    this.transcriptsLoading = false;
                    return;
                }

                this.transcriptsLoading = true;

                try {
                    const headers = { 'Authorization': 'Bearer ' + this.$store.state.auth.jwt };

                    // Reset current view data
                    const next = { bland: null, lsa_recordings: [], lsa_messages: [], web: null };

                    if (lead.sources.indexOf('web') != -1) {
                        const resp = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, { lead_id: lead.id }, { headers, timeout: 30000 });
                        const t = resp && resp.data ? resp.data.transcription : null;

                        if (t && t.messages && Array.isArray(t.messages)) {
                            next.web = {
                                messages: t.messages.map(m => ({
                                    sender: m.sender || ((m.is_person || m.role == 'user') ? 'human' : 'bot'),
                                    message: m.message || m.text || m.content || '',
                                    timestamp: m.timestamp || m.event_time || m.time || null
                                }))
                            };
                        } else {
                            next.web = { messages: [] };
                        }
                    }
                    else if (lead.sources.indexOf('bland') != -1) {
                        const resp = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, { lead_id: lead.id }, { headers, timeout: 30000 });
                        const t = resp && resp.data ? resp.data.transcription : null;

                        if (isCurrent()) lead.bland_recording_url = resp.data.recording_url;

                        // normalize to {messages:[{sender,message,timestamp}]}
                        if (t && t.messages && Array.isArray(t.messages)) {
                            next.bland = {
                                messages: t.messages.map(m => ({
                                    sender: m.sender || m.role ||  (m.is_person ? 'human' : 'bot'),
                                    message: m.message || m.text || m.content || '',
                                    timestamp: m.timestamp || m.event_time || m.time || null
                                }))
                            };
                        } else {
                            next.bland = { messages: [] };
                        }
                    }
                    else if (lead.sources.indexOf('lsa') != -1) {
                        if (lead.lead_type === 'PHONE_CALL') {
                            const resp = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-recordings`, { lead_id: lead.id }, { headers, timeout: 30000 });
                            next.lsa_recordings = (resp && resp.data && Array.isArray(resp.data.recordings)) ? resp.data.recordings : [];
                        } else {
                            const resp = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, { lead_id: lead.id }, { headers, timeout: 30000 });
                            const msgs = (resp && resp.data && Array.isArray(resp.data.lsa_messages)) ? resp.data.lsa_messages : [];
                            next.lsa_messages = msgs.map(m => ({
                                sender: (m.participant_type == 3) ? 'human' : 'bot',
                                message: m.text || m.message || m.content || '',
                                timestamp: m.event_time || m.timestamp || null
                            }));
                        }
                    }

                    if (!isCurrent()) return;
                    const hasContent = next.lsa_recordings.length || next.lsa_messages.length || (next.bland && next.bland.messages && next.bland.messages.length) || (next.web && next.web.messages && next.web.messages.length);
                    if (hasContent) this.transcriptCache[cacheKey] = JSON.parse(JSON.stringify(next));
                    else delete this.transcriptCache[cacheKey];
                    this.transcriptData = next;
                } catch (e) {
                    console.error('Failed to load transcript:', e);
                    if (isCurrent()) {
                        this.transcriptData = { bland: null, lsa_recordings: [], lsa_messages: [], web: null };
                        this.transcriptError = 'The transcript could not be loaded. Please retry.';
                    }
                } finally {
                    if (isCurrent()) this.transcriptsLoading = false;
                }
            },
            leadTypeLabel(item) {
                if (!item) return '-';
                if (item.sources === 'web' || (item.sources || '').indexOf('web') !== -1) return 'Chat';
                if (item.lead_type === 'PHONE_CALL') return 'Call';
                if (item.lead_type === 'MESSAGE') return 'Message';
                if (item.lead_type === 'BOOKING') return 'Booking';
                return item.lead_type || 'Lead';
            },
            providerLabel(key) {
                switch (key) {
                    case 'ai': return 'AI';
                    case 'lsa': return 'LSA';
                    case 'web': return 'Web Chat';
                    default: return (key || '').toUpperCase() || 'Channel';
                }
            },

            initFromUrl() {
                const hash = window.location.hash.slice(1); // "month=2026-02&leadId=319876"
                const params = new URLSearchParams(hash);

                const month = params.get("month");   // "2026-02"
                const leadId = params.get("leadId"); // "319876"

                console.log('month', month);
                console.log('leadId', leadId);

                if (month) {
                  this.selectedMonth = month;
                }

                if (leadId) {
                  this.$nextTick(() => {
                    this.openLeadWhenReady(leadId);
                  });
                }
              },

              openLeadWhenReady(leadId, {
                intervalMs = 250,
                timeoutMs = 15000,
                scroll = true
              } = {}) {
                const start = Date.now();

                const tryClick = () => {
                  const el = document.querySelector(`[data-lead-id="${leadId}"]`);

                  if (el) {
                    if (scroll) el.scrollIntoView({ behavior: "smooth", block: "center" });
                    el.click();
                    return; // done
                  }

                  if (Date.now() - start >= timeoutMs) {
                    console.warn(`Lead ${leadId} not found after ${timeoutMs}ms`);
                    return; // give up
                  }

                  setTimeout(tryClick, intervalMs);
                };

                tryClick();
              },

            openPhotosDialog(lead) {
                this.lead_id = lead.id

                if (lead.photos) {
                    this.photos = lead.photos.split(',')
                } else {
                    this.photos = []
                }

                this.show_photos_dialog = true
            },

            async onUpload() {
              // console.log(this.file);
              if (this.file !== null) {
                this.uploading = true
                let formData = new FormData()
                formData.append("file", this.file)

                try {
                  let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })

                  let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-profile-picture`, {
                    profile_image: response.data.url
                  }, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })

                  this.profile.profile_image = response.data.url

                }catch(e){
                  console.log(e)
                }

                this.file = null
                this.uploading = false
              }
            },

            handlePhotoUpload(event) {
                let self = this;
                let files = event.target.files
                this.uploading = true;

                for (let i = 0; i < files.length; i++) {
                    let formData = new FormData()
                    formData.append('file', files[i])

                    axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
                        headers: { 'Authorization': 'Bearer ' + self.$store.state.auth.jwt }
                    })
                    .then(res => {
                        self.photos.push(res.data.url)
                        self.uploading = false;
                    })
                }
            },

            removePhoto(index) {
                this.photos.splice(index, 1)
            },

            savePhotos() {
                let self = this;
                this.savingPhotos = true

                axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-lead-photos`, {
                      lead_id: this.lead_id,
                        photos: this.photos.join(',')
                  }, {
                      headers: {
                          'Authorization': 'Bearer ' + self.$store.state.auth.jwt
                      }
                  }).then(() => {
                    self.savingPhotos = false
                    self.show_photos_dialog = false
                    self.getMessages(true)
                })
                .catch(() => {
                    self.savingPhotos = false
                })
            },

            async switchAiResponseEnabled(lead) {
                console.log('lead', lead);

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-response-enabled`, {
                    lead_id: lead.id,
                    ai_enabled: lead.ai_enabled
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                console.log('response', response);
            },

            async sendLsaReply() {
                this.sendingLsaMessage = true;
                
                let self = this;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                    lead_id: self.lsa_messages_lead.id,
                    message: self.new_lsa_message
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                let timezone = this.me.timezone;

                this.lsa_messages_displayed.push({
                    event_time: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                    participant_type: 2,
                    text: self.new_lsa_message
                });

                this.sendingLsaMessage = false;
                this.new_lsa_message = "";

                setTimeout(function() {
                    var objDiv = document.getElementById("lsa-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            async sendAiReply() {
                this.sendingAiMessage = true;
                
                let self = this;

                console.log('this.bland_recording_data', this.bland_recording_data);

                if (this.bland_recording_data.sources && this.bland_recording_data.sources.indexOf('lsa') != -1) {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                        lead_id: this.bland_recording_data.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }
                else {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-ai-message`, {
                        lead_id: self.ai_messages_lead.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }

                let timezone = this.me.timezone;

                try {
                    this.bland_recording_data.transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        custom_name: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    });
                }
                catch (e) {

                }

                try {
                    this.bland_transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        content: self.new_ai_message,
                        custom_name: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    });
                }
                catch (e) {

                }

                this.sendingAiMessage = false;
                this.new_ai_message = "";

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("ai-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("chat-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }
            },

            async showChatConversation(item) {
                if (this.me.is_medical) return false;
                
                let self = this;

                this.shouldShowChatConversation = true;
                this.loading_chat_conversation = true;
                this.ai_messages_lead = item;

                if (this.ai_messages_lead.ai_enabled == 1)
                    this.ai_messages_lead.ai_enabled = true;
                else
                    this.ai_messages_lead.ai_enabled = false;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, {
                    lead_id: item.id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                this.bland_transcription = response.data.transcription;
                this.loading_chat_conversation = false;

                setTimeout(function() {
                    var objDiv = document.getElementById("chat-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            handleLegendHover(item) {
                this.hoveredLegend = item.name;

                this.legendItems.forEach(i => {
                  if (i.name !== item.name && !i.disabled) {
                    this.$refs.apexChart.hideSeries(i.name);
                  }
                });
              },

              handleLegendLeave() {
                this.hoveredLegend = null;

                this.legendItems.forEach(i => {
                  if (!i.disabled) {
                    this.$refs.apexChart.showSeries(i.name);
                  }
                });
              },

              toggleSeries(item) {
                item.disabled = !item.disabled;
                this.$refs.apexChart.toggleSeries(item.name);
              },

            async generateAiIntakePerformance(item) {
                this.$set(this.aiLoadingInakePerformanceById, item.id, true);
                try {
                let transcript = item.lsa_transcription;

                if (!transcript)
                    transcript = item.lsa_messages;

                const intake_performance = await this.callOpenAIForIntakePerformance(item.id, transcript);

                console.log('intake_performance', intake_performance);

                item.intake_performance = intake_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingInakePerformanceById, item.id, false);
                }
            },

            async generateAiPerformance(item) {
                this.$set(this.aiLoadingAiPerformanceById, item.id, true);
                try {
                let transcript = item.bland_transcription;

                const ai_performance = await this.callOpenAIForAiPerformance(item.id, transcript);

                console.log('ai_performance', ai_performance);

                item.ai_performance = ai_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingAiPerformanceById, item.id, false);
                }
            },

            async callOpenAIForIntakePerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-intake-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            async callOpenAIForAiPerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-ai-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            isLocalHost() {
                return this.getHost().indexOf('localhost') != -1;
            },

            getMonthlyReport() {
                window.open('/leads-public-survey/' + this.me.uuid + "?cutoff_date=" + moment().subtract(2, 'weeks').format('YYYY-MM-DD'));
            },

            async sendMonthlyReport(item, qualify_status) {
                setTimeout(function() {
                    this.$swal({
                        title: "Email sent!",
                        text: "The report has been successfully sent to the customer!",
                        showCancelButton: false,
                    });
                }, 1000);

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/send-monthly-survey-report`, {
                    now: 2
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                })
            },

            downloadCsv() {
                this.exporting = true;

                let self = this;

                let csv = 'Customer, Timestamp, Lead Type, Sources, Charge Status, Survey Score, Survey Notes, Intake Score, Intake Notes, AI Score, AI Rating\n';
                this.messages.forEach((row) => {

                    let customer = "";

                    if (row.job_type) {
                        customer = row.job_type + " - ";
                    }

                    if (row.tracking_number) {
                        customer += row.tracking_number;
                    }
                    else if (row.customer_phone_number) {
                        customer += row.customer_phone_number;
                    }

                    let tags = [];

                    for (var i in row.tag) {
                        for (var j in this.tags_items) {
                            if (this.tags_items[j].index == row.tag[i]) {
                                tags.push(this.tags_items[j].text);
                            }
                        }
                    }

                    let lead_status = "Not Set";

                    switch (row.qualify_status) {
                        case 1:
                            lead_status = 'Qualified';
                        break;
                        case -1:
                            lead_status = 'Unqualified';
                        break;
                        case 2:
                            lead_status = 'Spam';
                        break;
                    }

                    if (row.qualify_status != 0 && row.qualify_status != 1 && row.qualify_status != 2 && row.qualify_status != -1) {
                        lead_status = row.qualify_status;
                    }

                    let survey_score = "N/A";
                    let survey_notes = "N/A";
                    let intake_score = "N/A";
                    let intake_notes = "N/A";
                    let ai_score = "N/A";
                    let ai_notes = "N/A";

                    if (row.rated_at) {
                        survey_score = self.convertSatisfactionToNumber(row.satisfaction);

                        survey_notes = row.summary || row.additional_comments;
                    }

                    if (row.intake_performance) {
                        intake_score = row.intake_performance.rating;
                        intake_notes = row.intake_performance.explanation;
                    }

                    if (row.ai_performance) {
                        ai_score = row.ai_performance.rating;
                        ai_notes = row.ai_performance.explanation;
                    }

                    let csv_data = [
                        '"' + customer + '"',
                        '"' + self.displayTimestamp(row.lead_creation_date) + '"',
                        '"' + row.lead_type + '"',
                        '"' + row.sources.replace('bland', 'AI') + '"',
                        // '"' + tags.join(",") + '"',
                        '"' + row.charge_status + '"',
                        '"' + survey_score + '"',
                        '"' + survey_notes + '"',
                        '"' + intake_score + '"',
                        '"' + intake_notes + '"',
                        '"' + ai_score + '"',
                        '"' + ai_notes + '"'
                    ]

                    csv += csv_data.join(',');
                    csv += "\n";
                });

                csv = csv.replace(/null/g, "");
            
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'diyai-leads.csv';
                anchor.click();

                this.exporting = false;
            },

          async markBooked(item) {
                item.marking_booked = true;

                item.is_lsa_booked = true;

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/inbox/mark-lead-booked`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },

          async archiveLead(item) {

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/archive-lead`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },

          async unArchiveLead(item) {

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/unarchive-lead`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },
          async saveNote() {
              if (!this.new_note)
                  return;

              this.savingNote = true;
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/add-note`, {
                  lead_id: this.activeLead.id,
                  note: this.new_note
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.savingNote = false;
              this.activeLead = response.data.lsa_lead;
              this.new_note = '';

              this.getMessages(true);
          },

          async deleteNote(index) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/delete-note`, {
                  lead_id: this.activeLead.id,
                  note_index: index
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.activeLead = response.data.lsa_lead;

              this.getMessages(true);
          },

          async setTag(item, tag) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-tag-message`, {
                  message_id: item.id,
                  tag: tag
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              })

              this.activeLead = response.data.lead; this.showFullactiveLeadKey++;
              this.getMessages(true);
          },

          async removeTag(item, tag) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/remove-tag-message`, {
                  message_id: item.id,
                  tag: tag
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              })

              this.activeLead = response.data.lead; this.showFullactiveLeadKey++;
              this.getMessages(true);
          },
          showEditValue(item) {
              $('.lsa-show-value-' + item.id).hide();
              $('.lsa-edit-value-' + item.id).show();
              setTimeout(function() {
                  $('.lsa-edit-value-' + item.id).focus();
              }, 20);
          },

          cancelEditValue(item) {
              $('.lsa-show-value-' + item.id).show();
              $('.lsa-edit-value-' + item.id).hide();
          },

          async editValue(item) {
              item.value = $('.lsa-edit-value-' + item.id + ' input').val();
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-value-message`, {
                  item: item
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.activeLead = response.data.lead; this.showFullactiveLeadKey++;
              this.getMessages(true);

              $('.lsa-show-value').show();
              $('.lsa-edit-value').hide();
          },

          showEditCustomerName(item) {
                $('.lsa-show-customer-name-' + item.id).hide();
                $('.lsa-edit-customer-name-' + item.id).show();
                setTimeout(function() {
                    $('.lsa-edit-customer-name-' + item.id).focus();
                }, 20);
            },

            cancelEditCustomerName(item) {
                $('.lsa-show-customer-name-' + item.id).show();
                $('.lsa-edit-customer-name-' + item.id).hide();
            },

            async editCustomerName(item) {
                item.customer_name = $('.lsa-edit-customer-name-' + item.id + ' input').val();
                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-customer-name`, {
                    item: item
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                this.activeLead = response.data.lead; this.showFullactiveLeadKey++;

                this.getMessages(true);

                $('.lsa-show-customer-name').show();
                $('.lsa-edit-customer-name').hide();
            },


          displaySpeakerTimestamp(milliseconds, firstItemMilliseconds) {
              //Get hours from milliseconds
              var hours = milliseconds / (1000*60*60);

              //if (firstItemMilliseconds < 1000)
                //hours = milliseconds / (100*60*60);

              var absoluteHours = Math.floor(hours);
              var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

              //Get remainder from hours and convert to minutes
              var minutes = (hours - absoluteHours) * 60;
              var absoluteMinutes = Math.floor(minutes);
              var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

              //Get remainder from minutes and convert to seconds
              var seconds = (minutes - absoluteMinutes) * 60;
              var absoluteSeconds = Math.floor(seconds);
              var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

              return h + ':' + m + ':' + s;
        },

        async showBlandRecordingFunction(item) {

          this.ai_messages_lead = item;
          this.ai_messages_lead.show_ai_feedback = false;

          if (this.ai_messages_lead.ai_enabled == 1)
              this.ai_messages_lead.ai_enabled = true;
          else
              this.ai_messages_lead.ai_enabled = false;

          let self = this;

          this.showBlandRecording = true;
          this.loading_bland_recording = true;
          
          this.bland_recording_data.recording_url = item.bland_recording_url;
          this.bland_recording_data.sources = item.sources;
          this.bland_recording_data.lead_type = item.lead_type;
          this.bland_recording_data.id = item.id;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.bland_recording_data.transcription = response.data.transcription;

          let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
          original_ai_messages = original_ai_messages.messages;

          console.log('original_ai_messages', original_ai_messages);

          if (item.lead_type == "MESSAGE" && item.sources.indexOf('lsa') != -1) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                  lead_id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              for (var i in response.data.lsa_messages) {
                  response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                  response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                  response.data.lsa_messages[i].is_person = response.data.lsa_messages[i].is_bland;
                  // response.data.lsa_messages[i].is_person = 0;
                  response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                  response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                  for (var j in original_ai_messages) {
                      console.log('compare 1:', response.data.lsa_messages[i].message);
                      console.log('compare 2:', original_ai_messages[j].body);
                      if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                          console.log("FOUD AI MESSAGE");
                          console.log(response.data.lsa_messages[i].message);
                          response.data.lsa_messages[i].is_person = 0;
                          break;
                      }
                  }

                  if (response.data.lsa_messages[i].text.indexOf('did you get my last message') != -1) {
                      response.data.lsa_messages[i].is_person = 0;
                  }
              }

              this.bland_recording_data.transcription.messages = response.data.lsa_messages;
          }

          this.bland_recording_data.summary = response.data.summary;
          this.bland_recording_data.customer_name = item.customer_name;
          this.bland_recording_data.customer_email = item.customer_email;
          this.bland_recording_data.ai_provided_phone_number = item.ai_provided_phone_number;
          this.bland_recording_data.job_type = item.job_type;
          this.bland_recording_data.call_ended_by = item.call_ended_by;
          this.bland_recording_data.sentiment = response.data.sentiment;
          this.bland_recording_data.topics_discussed = response.data.topics_discussed;
          this.bland_recording_data.issues_raised = response.data.issues_raised;
          this.bland_recording_data.analysis = response.data.analysis;
          this.bland_recording_data.variables = response.data.variables;
          this.loading_bland_recording = false;

          if (response.data.recording_url)
              this.bland_recording_data.recording_url = response.data.recording_url;

          setTimeout(function() {
              if (self.bland_recording_data.recording_url) {
                  document.querySelector('#bl-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.bland_recording_data.recording_url + '" style="width: 100%"></audio>';
              }
          }, 500);

          setTimeout(function() {
              var objDiv = document.getElementById("ai-dialog-messages-list");
              objDiv.scrollTop = objDiv.scrollHeight;
          }, 10);
      },

      async showLsaCallRecordings(item) {
          
          let self = this;

          console.log('this.lsa_item', this.lsa_item);

          this.showLsaRecordings = true;
          this.loading_lsa_recording = true;
          this.lsa_item = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-recordings`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_recordings = false;

          this.lsa_recording_data = JSON.parse(JSON.stringify(response.data));

          console.log('this.lsa_recording_data', this.lsa_recording_data);

          if (response.data.recordings.length > 0) {
              let recordings_html = '';

              for (var i in response.data.recordings) {
                  recordings_html += '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><div style="margin-bottom: 15px;"><audio onwindowresize="" controls="true" class="u-hide" src="' + response.data.recordings[i] + '" style="width: 100%"></audio></div>';
              }

              setTimeout(function() {
                  document.querySelector('#lsa-audio-el-here').innerHTML = recordings_html;
              }, 500);
          }
          else {
              document.querySelector('#lsa-audio-el-here').innerHTML = 'No recordings found.';
          }
      },

      async showLsaMessagesFunction(item) {
      
          // console.log('item.sources', item.sources)
          // console.log('itemplmmmm', item);

          // console.log(1);

          // console.log("item.sources.indexOf('bland')", item.sources.indexOf('bland'))

          if (item.sources.indexOf('bland') != -1) {
              console.log(2);
              this.showBlandRecordingFunction(item);
              return;
          }

          console.log(3);

          
          let self = this;

          this.showLsaMessages = true;
          this.loading_lsa_messages = true;
          this.lsa_messages_lead = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_messages = false;

          this.lsa_messages_displayed = response.data.lsa_messages;
          this.loading_lsa_messages = false;
      },

        readCutoffFromQuery() {
          const params = new URLSearchParams(window.location.search);
          const cutoff = params.get("cutoff_date");

          if (cutoff && moment(cutoff, "YYYY-MM-DD", true).isValid()) {
            this.cutoffDate = moment(cutoff, "YYYY-MM-DD").startOf("day");
          } else {
            this.cutoffDate = moment().subtract(2, 'weeks').format('YYYY-MM-DD');
          }
        },

        isNewLead(item) {
          if (!this.cutoffDate || !item.lead_creation_date) return false;

          const leadDate = moment(item.lead_creation_date, "YYYY-MM-DD HH:mm:ss", true);
          if (!leadDate.isValid()) return false;

          return leadDate.isAfter(this.cutoffDate);
        },

        getRowClass(item) {
          return this.isNewLead(item) ? "new-lead-highlight" : "";
        },

        getHost() {
        return window.location.host;
        },

        isOnlyAi() {
            return !this.isAccelerate();
        },

        isAccelerate() {
            //  || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
            return this.getHost() == 'lsa.accelerateyourmarketing.com';
        },

        getCustomTagColor(tag) {
            for (var i in this.custom_tags) {
                if (this.custom_tags[i].tag == tag)
                    return this.custom_tags[i].color;
            }

            return "";  
        },

        getCustomStatusColor(status) {
            for (var i in this.custom_statuses) {
                if (this.custom_statuses[i].status == status)
                    return this.custom_statuses[i].color;
            }

            return "";  
        },

        formatDate: function(date, format = "MM/DD/YYYY") {
            return moment(String(date)).format(format)
        },

        displayTimestamp(date) {
            let timezone = "America/New_York";

            // .tz(timezone)
            return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
        },

        displayDuration(seconds) {
            return date;
        },

        trainAgentWithSelectedCalls() {
            this.selected = [];

            this.$swal({
                title: "Saved",
                text: "Selected calls will be used as knowledge for AI Agent, based on each call's quality!",
                showCancelButton: false,
            });
        },
        
        satisfactionLabel(value) {
            const map = {
                1: 'Very Satisfied',
                2: 'Satisfied',
                3: 'Neutral',
                4: 'Unsatisfied',
                5: 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        satisfactionLabelByTexts(value) {
            const map = {
                "VERY_SATISFIED": 'Very Satisfied',
                "SATISFIED": 'Satisfied',
                "NEUTRAL": 'Neutral',
                "DISSATISFIED": 'Unsatisfied',
                "VERY_DISSATISFIED": 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        convertSatisfactionToNumber(value) {
            const map = {
                "VERY_SATISFIED": 5,
                "SATISFIED": 4,
                "NEUTRAL": 3,
                "DISSATISFIED": 2,
                "VERY_DISSATISFIED": 1
            };
            return map[value] || 3;
        },

        convertCreditDecisionToNumber(value) {
            const map = {
                'Not specified': 3,
                'Unknown in this API version': 3,
                'Credit issued, cap not reached': 5,
                'Credit issued, cap reached': 4,
                'No credit, cap reached': 2,
                'No credit, not eligible': 1

            };
            return map[value] || 3;
        },

        getSatisfactionColor(value) {
            const map = {
                "1": "#ef4444",
                "2": "#fb923c",
                "3": "#facc15",
                "4": "#22c55e",
                "5": "#16a34a"
            };

            return map[value];
        },

        reasonLabel(reason) {
            // If you store reasons as strings already, just return them.
            // If your backend uses codes, map those codes to labels here.
            return reason || '—';
        },

        normalizedProviders(item) {
            // Build a unique set of providers from item.sources ONLY ONCE
            const src = (item.sources || '').toLowerCase()
            const list = []
            const push = (cond, key, title, srcImg, onClick) => {
            if (cond) list.push({ key, title, src: srcImg, onClick })
            }


            // Important: render EACH provider ONCE. We no longer render separate icons for call/message.
            push(src.includes('lsa'), 'lsa', 'This is a Google Local Service Ads lead', require('@/assets/images/lsa.webp'), (row) => {
            // prefer messages when lead_type is MESSAGE, else show call recordings
            if (row.lead_type === 'MESSAGE') this.showLsaMessagesFunction(row)
            else this.showLsaCallRecordings(row)
            })


            push(src.includes('callrail'), 'callrail', 'CallRail', require('@/assets/images/callrail.png'), (row) => this.showCallRailRecordingFunction(row))


            push(src.includes('bland'), 'ai', 'This is a call that we responded to using AI', require('@/assets/images/bland.png'), (row) => this.showBlandRecordingFunction(row))


            push(src.includes('web'), 'web', 'This is a Web Chat conversation', require('@/assets/images/bland.png'), (row) => this.showChatConversation(row))

            push(src.includes('google_ai'), 'google_ai', 'This is a call that came in using Google AI', require('@/assets/images/review-services/www.google.com.png'), (row) => this.showChatConversation(row))

            push(src.includes('lead_form'), 'lead_form', 'This is a lead that was captured on the Website Lead Form', require('@/assets/images/lead_form.png'), (row) => {

            });


            // Avoid duplicate icons added from merged_lead by ONLY using current row sources.
            // If you want to show merged sources too, dedupe by key:
            // const merged = (row.merged_lead?.[0]?.sources || '').toLowerCase()
            // ... add conditionally if not already in list.


            // De-duplicate by key just in case
            const seen = new Set()
            return list.filter(p => (seen.has(p.key) ? false : seen.add(p.key)))
        },

        displayDuration(time) {
            var sec_num = time // don't forget the second param
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            return hours+':'+minutes+':'+seconds;
        },

        formatPhoneNumber(phoneNumberString) {
            const match = phoneNumberString
    .replace(/\D+/g, '').replace(/^1/, '')
    .match(/([^\d]*\d[^\d]*){1,10}$/)[0]
    const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
    const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
    const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
    return `${part1}${part2}${part3}`
        },

        playAudio(item) {
            if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
                let elements = document.getElementsByClassName('audio-element-wrapper');

                for (var i in elements) {
                    try {
                        elements[i].style.display = 'none';
                    }
                    catch (e) {}
                }

                let elements2 = document.getElementsByClassName('audio-element');

                for (var i in elements) {
                    try {
                        elements2[i].pause();
                        elements2[i].currentTime = 0;
                    }
                    catch (e) {}
                }

                let elements3 = document.getElementsByClassName('audio-element-icon');

                for (var i in elements) {
                    try {
                        elements3[i].style.display = 'block';
                    }
                    catch (e) {}
                }

                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
                document.getElementById('audio-element-' + item.id).play();

                document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

                
            }
            else {
                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
                document.getElementById('audio-element-' + item.id).pause();
                document.getElementById('audio-element-' + item.id).currentTime = 0;

                document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
            }
        },

        async getMessages(silent = false) {
            let self = this;

            if (!silent) {
                this.loadingMessages = true;
                this.loading = true;
            }

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
                date_filter: this.date_filter,
                search: this.search,
                tag: this.tag,
                qualify_status: this.qualify_status,
                archived_filter: this.archived_filter,
                // month: this.selectedMonth
            }, {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
            })

            this.messages = response.data.messages;
            this.lsa_leads_count = response.data.lsa_leads_count;
            this.ai_leads_count = response.data.ai_leads_count;
            this.ai_leads_count_msg = response.data.ai_leads_count_msg;
            this.ai_leads_count_voice = response.data.ai_leads_count_voice;
            this.callrail_leads_count = response.data.callrail_leads_count;
            this.converted_leads_count = response.data.converted_leads_count;
            this.converted_ai_leads_count = response.data.converted_ai_leads_count;
            this.converted_human_leads_count = response.data.converted_human_leads_count;
            this.booked_leads_count = response.data.booked_leads_count;
            this.booked_ai_leads_count = response.data.booked_ai_leads_count;
            this.booked_human_leads_count = response.data.booked_human_leads_count;

            this.company_name = response.data.company_name;
            this.uuid = response.data.uuid;
            this.ai_started_on = response.data.ai_started_on;
            this.survey_started_on = response.data.survey_started_on;


            this.loadingMessages = false;

            await this.loadDashboard();
            await this.loadDashboard2();

            this.loading = false;
        },

        getUUID() {
          return (this.me) ? this.me.uuid : this.$route.params.uuid;
        },

        async doCreated() {
            let self = this

            self.generateMonths();
            if (this.months.length > 0) {
                this.selectedMonth = this.months[0].value;
                this.updateMonthDates(this.selectedMonth); // Set the dates for the current month
            }

            self.getMessages();
        },

        generateMonths() {
          const now = new Date();
          const result = [];

          for (let i = 0; i < 6; i++) {
            const date = new Date(
              now.getFullYear(),
              now.getMonth() - i,
              1
            );

            const value = `${date.getFullYear()}-${String(
              date.getMonth() + 1
            ).padStart(2, '0')}`;

            const label = date.toLocaleString('default', {
              month: 'short',
              year: 'numeric'
            });

            result.push({ value, label });
          }

          this.months = result;
        },

        updateMonthDates() {
          if (!this.selectedMonth) return;

          const [year, month] = this.selectedMonth.split('-');
          this.startDate = `${year}-${month}-01`;

          // Get the last day of the month
          const lastDay = new Date(year, month, 0).getDate();
          this.endDate = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
        },

        async loadDashboard() {

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: this.date_filter[0],
                end_date: this.date_filter[1],
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data = response.data.dashboard_data;

            let diff_days = moment(this.date_filter[1]).diff(this.date_filter[0], 'days') + 1;

            console.log('diff_days', diff_days);

            let date_prev_start = moment(this.date_filter[0]).subtract(diff_days, 'days').format('YYYY-MM-DD');
            let date_prev_end = moment(this.date_filter[1]).subtract(diff_days, 'days').format('YYYY-MM-DD');

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency != 'Frequency: Auto') {
              date_prev_start = moment(this.date_filter[0]).subtract(1, 'months').format('YYYY-MM-DD');
              date_prev_end = moment(date_prev_start).endOf('month').format('YYYY-MM-DD');
            }

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency == 'Frequency: Auto') {
              date_prev_start = moment(this.date_filter[0]).subtract(1, 'months').format('YYYY-MM-DD');
              date_prev_end = moment(date_prev_start).add(1, 'months').format('YYYY-MM-DD');
            }

            console.log('date_prev_start', date_prev_start);
            console.log('date_prev_end', date_prev_end);

            function toBinaryStr(str) {
              const encoder = new TextEncoder();
              // 1: split the UTF-16 string into an array of bytes
              const charCodes = encoder.encode(str);
              // 2: concatenate byte data to create a binary string
              return String.fromCharCode(...charCodes);
            }

            this.reviewsScoreData = btoa(toBinaryStr(JSON.stringify(response.data.reviewsScoreData)));


            let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: date_prev_start,
                end_date: date_prev_end,
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data_prev = response2.data.dashboard_data;
            
            this.calculateComparisons();
          },

        async loadDashboard2() {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: moment().subtract(5, 'months').startOf('month').format('YYYY-MM-DD'),
                end_date: moment().endOf('month').format('YYYY-MM-DD'),
                all_time: 0,
                selected_frequency: "Monthly",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            if (this.ai_started_on) {
                for (var i in response.data.dashboard_data.metrics_chart.labels) {
                    if (moment(response.data.dashboard_data.metrics_chart.labels[i]) >= moment(this.ai_started_on)) {
                        response.data.dashboard_data.metrics_chart.labels[i] = response.data.dashboard_data.metrics_chart.labels[i];
                    }
                }
            }

            this.lineChartMetricsOptions.xaxis.categories = response.data.dashboard_data.metrics_chart.labels;

            this.lineChartMetricsOptions.annotations = {
                xaxis: [
                  {
                    x: moment(this.ai_started_on).format('MMM YYYY'),
                    borderColor: "#008FFB",
                    strokeDashArray: 4,
                    label: {
                      borderColor: "#008FFB",
                      style: {
                        color: "#fff",
                        background: "#008FFB"
                      },
                      text: "AI Started " + moment(this.ai_started_on).format('MM/DD')
                    }
                  },
                  {
                    x: moment(this.survey_started_on).format('MMM YYYY'),
                    borderColor: "#FF4560",
                    strokeDashArray: 4,
                    label: {
                      borderColor: "#FF4560",
                      style: {
                        color: "#fff",
                        background: "#FF4560"
                      },
                      text: "Survey Started " + moment(this.survey_started_on).format('MM/DD')
                    }
                  }
                ]
              }

            this.lineChartMetricsSeries = [
              {
                name: 'Impressions',
                data: response.data.dashboard_data.metrics_chart.datasets['Impressions']
              },
              {
                name: 'Absolute Top Impressions Rate',
                data: response.data.dashboard_data.metrics_chart.datasets['Absolute Top Impressions']
              },
              {
                name: 'Under 30s Response Rate',
                data: response.data.dashboard_data.metrics_chart.datasets['Under 30s Response Rate']
              },
              {
                name: 'Lead Volume',
                data: response.data.dashboard_data.metrics_chart.datasets['Lead Volume']
              },
              {
                name: 'Clicks',
                data: response.data.dashboard_data.metrics_chart.datasets['Clicks']
              },
              {
                name: 'Total Cost',
                data: response.data.dashboard_data.metrics_chart.datasets['Cost']
              },
              {
                name: 'Lead Quality',
                data: response.data.dashboard_data.metrics_chart.datasets['Lead Quality']
              },
              {
                name: 'Credited',
                data: response.data.dashboard_data.metrics_chart.datasets['Credited']
              }
            ];
          },

      calculateComparison(data_now, data_previous) {
        data_now = parseFloat(data_now);
        data_previous = parseFloat(data_previous);

        if (data_now == 0 && data_previous == 0)
          return 0.00;

        if (data_now > 0 && data_previous == 0)
          return 100.00;

        if (data_now == 0 && data_previous > 0)
          return 100.00;

        let percentage;

        if (data_now > data_previous) {
          let x = (data_previous/data_now) * 100
          percentage = 100 - x;
        }
        else {
          let x = (data_now/data_previous) * 100
          percentage = 100 - x;
        }

        if (percentage <= 0)
          percentage = percentage * -1;

        percentage = percentage.toFixed(2);

        return percentage;
      },

      calculateComparisons() {
        // Charged Leads Total
        this.comparisons.charged_leads_total = this.calculateComparison(this.dashboard_data.charged_leads_total, this.dashboard_data_prev.charged_leads_total);
        // END Charged Leads Total


        // Not Charged Leads Total
        this.comparisons.not_charged_leads = this.calculateComparison(this.dashboard_data.not_charged_leads, this.dashboard_data_prev.not_charged_leads);
        // END Not Charged Leads Total


        // Total Leads
        this.comparisons.total_leads = this.calculateComparison(this.dashboard_data.total_leads, this.dashboard_data_prev.total_leads);
        // END Total Leads

        
        // Lead Quality
        this.comparisons.lead_quality = this.calculateComparison(this.dashboard_data.lead_quality, this.dashboard_data_prev.lead_quality);
        // END Lead Quality


        // Total Calls
        this.comparisons.total_calls = this.calculateComparison(this.dashboard_data.total_calls, this.dashboard_data_prev.total_calls);
        // END Total Calls


        // Total Connected Calls
        this.comparisons.total_connected_calls = this.calculateComparison(this.dashboard_data.total_connected_calls, this.dashboard_data_prev.total_connected_calls);
        // END Total Connected Calls


        // Total Message Leads
        this.comparisons.total_message_leads = this.calculateComparison(this.dashboard_data.total_message_leads, this.dashboard_data_prev.total_message_leads);
        // END Total Message Leads


        // Qualified Leads
        this.comparisons.charged_leads = this.calculateComparison(this.dashboard_data.stats.charged_leads, this.dashboard_data_prev.stats.charged_leads);
        // END Qualified Leads


        // Approved Disputes
        this.comparisons.approved_disputes = this.calculateComparison(this.dashboard_data.stats.approved_disputes, this.dashboard_data_prev.stats.approved_disputes);
        // END Approved Disputes


        // Converted Customers
        this.comparisons.converted_customers = this.calculateComparison(this.dashboard_data.stats.converted_customers, this.dashboard_data_prev.stats.converted_customers);
        // END Converted Customers

        // Converted Customers AI
        this.comparisons.converted_customers_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_ai, this.dashboard_data_prev.stats.converted_customers_ai);
        // END Converted Customers AI

        // Converted Customers NON AI
        this.comparisons.converted_customers_non_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_non_ai, this.dashboard_data_prev.stats.converted_customers_non_ai);
        // END Converted Customers NON AI


        // Conversion
        this.comparisons.conversion = this.calculateComparison(this.dashboard_data.stats.conversion, this.dashboard_data_prev.stats.conversion);
        // END Conversion


        // ROI
        this.comparisons.roi = this.calculateComparison(this.dashboard_data.stats.roi, this.dashboard_data_prev.stats.roi);
        // END ROI


        // Total Converted Value
        this.comparisons.total_converted_value = this.calculateComparison(this.dashboard_data.stats.total_converted_value, this.dashboard_data_prev.stats.total_converted_value);
        // END Total Converted Value


        // LSA Response Rate
        this.comparisons.lsa_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_response_rate, this.dashboard_data_prev.stats.lsa_response_rate);
        // END LSA Response Rate


        // LSA Response in less than 30s Rate
        this.comparisons.lsa_30_seconds_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_30_seconds_response_rate, this.dashboard_data_prev.stats.lsa_30_seconds_response_rate);
        // END LSA Response in less than 30s Rate


        // LSA Messages Average Response Rate
        this.comparisons.lsa_messages_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_messages_response_rate, this.dashboard_data_prev.stats.lsa_messages_response_rate);
        // END LSA Messages Average Response Rate


        // Total Impressions
        this.comparisons.total_impressions = this.calculateComparison(this.dashboard_data.stats.total_impressions, this.dashboard_data_prev.stats.total_impressions);
        // END Total Impressions


        // Total Clicks
        this.comparisons.total_clicks = this.calculateComparison(this.dashboard_data.stats.total_clicks, this.dashboard_data_prev.stats.total_clicks);
        // END Total Clicks


        // Total Cost
        this.comparisons.total_cost = this.calculateComparison(this.dashboard_data.stats.total_cost, this.dashboard_data_prev.stats.total_cost);
        // END Total Cost


        // Total Conversions
        this.comparisons.total_conversions = this.calculateComparison(this.dashboard_data.conversions_stats.total_conversions, this.dashboard_data_prev.conversions_stats.total_conversions);
        // END Total Conversions


        // Conversion Rate
        this.comparisons.conversion_rate = this.calculateComparison(this.dashboard_data.conversions_stats.conversion_rate, this.dashboard_data_prev.conversions_stats.conversion_rate);
        // END Conversion Rate


        // Pending Estimates
        this.comparisons.pending_estimates = this.calculateComparison(this.dashboard_data.conversions_stats.pending_estimates, this.dashboard_data_prev.conversions_stats.pending_estimates);
        // END Pending Estimates
      }
    },

    destroyed() {
        clearTimeout(this.thisProc);
        this.thisProc = null;
    },

    created() {
        this.initFromUrl();
        this.readCutoffFromQuery();
        this.doCreated();
    },

    watch: {
      selectedMonth: {
        async handler(newMonth) {
          // await this.fetchLeads(newMonth);

          // this.$nextTick(() => {
          //   const hash = window.location.hash.substring(1);
          //   const params = new URLSearchParams(hash);
          //   const leadId = params.get('leadId');

          //   if (leadId) {
          //     this.openLeadWhenReady(leadId);
          //   }
          // });
        },
        immediate: true
      }
   ,
      leadDialogTab(newVal) {
        if (newVal === 'transcripts') {
          this.$nextTick(() => this.loadActiveTranscript({ force: true }));
        }
      },
      activeLeadChannel() {
        if (this.leadDialogTab === 'transcripts') {
          this.loadActiveTranscript();
        }
      },
      activeLead() {
        if (this.leadDialogTab === 'transcripts') {
          this.$nextTick(() => this.loadActiveTranscript({ force: true }));
        }
      }
    }
}
</script>


<style scoped>
.lead-type-icon {
  font-size: 16px;
  color: #999898;
  margin-right: 6px;
}

.intake-tooltip {
  max-width: 320px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
}

/* Normalize icon look/feel so they don't jump around across rows */
.rg-channel-icon {
    width: 22px;
    height: 22px;
    display: inline-block;
    object-fit: contain;
}

.custom-text-field .v-input__control input {
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid red;
}
.header-inputs {
border-color: white !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
color: rgba(0, 0, 0, 0.38);
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid white !important;
}

.status-chip {
font-weight: bold;
text-transform: uppercase;
}

.status-Qualified {
color: green !important;
border-color: green !important;

}

.status-inQualified {
color: red;
border-color: red;
}

.custom-badge {
background-color: rgba(0, 230, 130, 0.1) !important;
color: #09ad95 !important;
}

.tags {
color: #e0e0e0;
font-size: small;
padding-left: 5px;

}

.icon-container {
display: flex;
align-items: center;
justify-content: center;
width: 48px;
height: 48px;
border-radius: 50%;
border: 2px solid #ccc;
cursor: pointer;
}

.icon {
font-size: 24px;
}

textarea:focus, input:focus{
    outline: none;
}

.stats-btn .stats-div {
    display: none;
}

.stats-btn:hover .stats-div {
    display: block;
}
</style>

<style scoped>
.score-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.legend-title {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
}

.legend-items {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
}

.legend-badge {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

/* Score colors */
.score-1 { background: #16a34a; } /* very good */
.score-2 { background: #22c55e; } /* good */
.score-3 { background: #facc15; color: #FFFFFF; } /* neutral */
.score-4 { background: #fb923c; } /* bad */
.score-5 { background: #ef4444; } /* very bad */




/* ===== Revamp: list + modal ===== */
.rg-lead-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rg-lead-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 12px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.rg-lead-card:hover {
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  transform: translateY(-1px);
}

.rg-lead-card.is-active {
  border-color: #c7d2fe;
  box-shadow: 0 10px 30px rgba(79,70,229,0.10);
}

.lead--checked {
  opacity: 0.35;
  filter: grayscale(0.35);
}

.lead--checked:hover {
  opacity: 0.75; /* still readable on hover */
  filter: none;
}

.rg-lead-title {
  font-weight: 700;
  font-size: 14px;
  color: #111827;
}

.rg-lead-sub {
  margin-top: 2px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.rg-lead-metrics {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.rg-muted { color: #6b7280; }
.rg-dot { color: #9ca3af; }

.rg-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #111827;
}

.rg-pill--ok { background: rgba(16,185,129,0.10); border-color: rgba(16,185,129,0.25); color: #065f46; }
.rg-pill--neutral { background: #f3f4f6; color: #374151; }
.rg-pill--warn { background: rgba(245, 197, 24, 0.25); border-color: rgba(245, 197, 24, 0.45); color: #92400e; }
.rg-pill--soft { background: #f3f4f6; color: #374151; }
.rg-pill--money { background: rgba(34,197,94,0.10); border-color: rgba(34,197,94,0.25); color: #166534; }

.rg-lead-card__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.rg-channels {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.rg-icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rg-icon-btn:hover { background: #f9fafb; }

.rg-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.rg-link {
  border: 0;
  background: transparent;
  padding: 6px;
  border-radius: 10px;
}

.rg-link:hover { background: #f3f4f6; }

.starred-icon {
  color: #ff9800; /* bright orange */
}

.rg-empty {
  padding: 16px;
  text-align: center;
  color: #6b7280;
}

/* Modal */
.rg-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.rg-modal {
  width: min(920px, 100%);
  max-height: calc(100% - 32px);
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 30px 70px rgba(0,0,0,0.25);
  display: flex;
  flex-direction: column;
}

.rg-modal__header {
  padding: 14px 16px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.rg-modal__title { font-size: 16px; font-weight: 800; color: #111827; }
.rg-modal__subtitle { margin-top: 2px; font-size: 12px; color: #6b7280; }

.rg-close {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px;
  width: 40px;
  height: 40px;
}

.rg-close:hover { background: #f9fafb; }

.rg-modal__tabs {
  padding: 8px 10px;
  display: flex;
  gap: 6px;
  border-bottom: 1px solid #e5e7eb;
  background: #fafafa;
}

.rg-tab {
  border: 1px solid transparent;
  background: transparent;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #374151;
}

.rg-tab.active {
  background: #fff;
  border-color: #e5e7eb;
  color: #111827;
}

.rg-modal__body {
  padding: 14px 16px;
  overflow: auto;
}

.rg-modal__footer {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.rg-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 700px) {
  .rg-lead-card { grid-template-columns: 1fr; }
  .rg-lead-card__right { align-items: flex-start; }
  .rg-grid { grid-template-columns: 1fr; }
}

.rg-kv {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  background: #fff;
}

.rg-k { font-size: 12px; color: #6b7280; font-weight: 700; }
.rg-v { margin-top: 4px; color: #111827; font-size: 13px; }
.rg-channels-inline { display: flex; flex-wrap: wrap; gap: 6px; }

.rg-note-block {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  background: #fff;
  margin-bottom: 12px;
}
.rg-note { margin-top: 6px; color: #111827; font-size: 13px; white-space: pre-wrap; }

.rg-note-actions { margin-top: 8px; }

.rg-primary, .rg-secondary {
  border-radius: 12px;
  padding: 10px 12px;
  font-weight: 800;
  font-size: 13px;
  border: 1px solid #e5e7eb;
}

.rg-primary { background: #111827; color: #fff; border-color: #111827; }
.rg-primary:hover { background: #0b1220; }
.rg-secondary { background: #fff; color: #111827; }
.rg-secondary:hover { background: #f9fafb; }

.rg-channel-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.rg-chip-tab {
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 800;
  background: #fff;
  color: #374151;
}

.rg-chip-tab.active {
  background: #111827;
  border-color: #111827;
  color: #fff;
}

/* prevent background scroll while modal is open */
.rg-modal-open { overflow: hidden !important; }


</style>

<style type="text/css">
  .new-lead-highlight {
    background-color: #fff7cc !important;
    border-left: 4px solid #f5c518 !important;
  }


  html.rg-modal-open, body.rg-modal-open {
    overflow: hidden !important;
  }

  .new-lead-highlight td {
    background-color: #fff7cc !important;
  }

  .custom-legend.centered {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 12px;
}

.custom-legend-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
  opacity: 1;
}

.custom-legend-item.dimmed {
  opacity: 0.3;
}

.custom-legend-item.disabled {
  opacity: 0.3;
}


.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;
  display: inline-block;
}

.legend-label {
  font-size: 13px;
  font-weight: 400;
  color: #444;
}

</style>